/* Übersetzung: der deutsche Text ist der Schlüssel, window.GHi18n (assets/gh-i18n-<sprache>.js) liefert die Übersetzung. Ohne Wörterbuch bleibt alles deutsch. */
window.GHt = window.GHt || function (s, v) { var d = window.GHi18n || {}, r = d[s] != null ? d[s] : s; if (v) for (var k in v) r = r.split('{' + k + '}').join(v[k]); return r; };
window.GHloc = window.GHloc || (function () { var full = document.documentElement.lang || 'de', l = full.slice(0, 2); return full.indexOf('-') > 0 ? full : l === 'de' ? 'de-DE' : l === 'en' ? 'en-GB' : l; })();
/* GreenHec theme JS — header, own cart drawer, product page, reviews (no apps) */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const NBSP = ' ';

  /* ---------- money ---------- */
  function money(cents, fmt) {
    fmt = fmt || (window.GH && GH.moneyFormat) || '{{amount_with_comma_separator}} €';
    const n = (cents / 100);
    const two = n.toFixed(2);
    const comma = two.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const dot = two.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n).toString())
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
      .replace(/\{\{\s*amount\s*\}\}/, dot)
      .replace(/(\d)\s*€/, '$1' + NBSP + '€');
  }
  window.GHmoney = money;
  const fmt = c => money(c, window.GH && GH.moneyFormat);

  /* ---------- announcement (rotating, arrows on mobile) ---------- */
  $$('.gh-ann').forEach(bar => {
    const msgs = $$('.gh-ann__msg', bar); if (msgs.length < 2) return;
    let i = 0, t;
    const show = k => { msgs[i].classList.remove('is-on'); i = (k + msgs.length) % msgs.length; msgs[i].classList.add('is-on'); };
    const start = () => { clearInterval(t); if (!reduce) t = setInterval(() => show(i + 1), 5000); };
    $$('[data-ann]', bar).forEach(b => b.addEventListener('click', () => { show(i + (+b.dataset.ann)); start(); }));
    start();
  });

  /* ---------- overlays: menu drawer, search, cart share one manager ---------- */
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const layers = {
    menu: { el: $('#gh-drawer'), scrim: $('#gh-scrim'), btn: $('#gh-burger') },
    search: { el: $('#gh-search'), scrim: $('#gh-scrim') },
    cart: { el: $('#gh-cart'), scrim: $('#gh-cart-scrim') },
    added: { el: $('#gh-added'), scrim: $('#gh-added-scrim') }
  };
  let lastFocus = null;
  const hideLayer = k => { const l = layers[k]; if (!l || !l.el) return; l.el.classList.add('gh-hidden'); l.scrim && l.scrim.classList.add('gh-hidden'); l.btn && l.btn.setAttribute('aria-expanded', 'false'); };
  function openLayer(n) {
    const l = layers[n]; if (!l || !l.el) return;
    Object.keys(layers).forEach(k => { if (k !== n) hideLayer(k); });
    if (!lastFocus) lastFocus = document.activeElement;
    l.el.classList.remove('gh-hidden'); l.scrim && l.scrim.classList.remove('gh-hidden');
    document.body.style.overflow = 'hidden';
    l.btn && l.btn.setAttribute('aria-expanded', 'true');
    if (n === 'menu') l.el.classList.remove('is-lvl2');
    if (n === 'search') { const i = $('#gh-q'); setTimeout(() => i && i.focus(), 40); }
    if (n === 'cart') setTimeout(() => l.el.focus(), 40);
  }
  function closeLayers() {
    Object.keys(layers).forEach(hideLayer); document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} } lastFocus = null;
  }
  const layerOpen = () => Object.keys(layers).find(k => layers[k].el && !layers[k].el.classList.contains('gh-hidden'));
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-gh-open]'); if (o) { e.preventDefault(); openLayer(o.dataset.ghOpen); return; }
    if (e.target.closest('[data-gh-close],#gh-drawer-close') || e.target.classList.contains('gh-scrim')) closeLayers();
  });
  $('#gh-burger') && $('#gh-burger').addEventListener('click', () => openLayer('menu'));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && layerOpen()) { closeLayers(); return; }
    if (e.key === '/' && layers.search.el && !/input|textarea|select/i.test(document.activeElement.tagName)) { e.preventDefault(); openLayer('search'); return; }
    if (e.key !== 'Tab') return;
    const k = layerOpen(); if (!k) return;
    const f = $$('a[href],button:not([disabled]),input:not([type=hidden]),summary,[tabindex="0"]', layers[k].el).filter(x => x.offsetParent); if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  const closeD = closeLayers;

  /* menu drawer: second level */
  const drawer = layers.menu.el;
  drawer && drawer.addEventListener('click', e => {
    const b = e.target.closest('[data-sub]');
    if (b) { $$('.gh-drawer__p--sub', drawer).forEach(p => p.classList.toggle('is-on', p.dataset.panel === b.dataset.sub)); drawer.classList.add('is-lvl2'); const p = $('.gh-drawer__p--sub.is-on', drawer); if (p) p.scrollTop = 0; return; }
    if (e.target.closest('[data-back]')) drawer.classList.remove('is-lvl2');
  });

  /* mega menu on touch devices: first tap opens */
  if (window.matchMedia('(hover: none)').matches) {
    $$('.gh-nav__item--mega > .gh-nav__link').forEach(a => a.addEventListener('click', e => {
      const item = a.parentElement;
      if (!item.classList.contains('is-open')) { e.preventDefault(); $$('.gh-nav__item.is-open').forEach(x => x.classList.remove('is-open')); item.classList.add('is-open'); }
    }));
    document.addEventListener('click', e => { if (!e.target.closest('.gh-nav__item')) $$('.gh-nav__item.is-open').forEach(x => x.classList.remove('is-open')); });
  }

  /* header hides on scroll down, returns on scroll up (mobile) */
  const hdr = $('#gh-header');
  if (hdr) {
    let ly = scrollY;
    addEventListener('scroll', () => {
      const y = scrollY;
      if (innerWidth >= 1024) { hdr.classList.remove('is-away'); ly = y; return; }
      if (y > 140 && y > ly + 6) hdr.classList.add('is-away'); else if (y < ly - 6 || y < 80) hdr.classList.remove('is-away');
      ly = y;
    }, { passive: true });
  }

  /* rotating search placeholder */
  const sph = $('#gh-sph'), terms = ((window.GH && GH.searchTerms) || []).map(s => s.trim()).filter(Boolean);
  if (sph && terms.length > 1 && !reduce) { let k = 0; setInterval(() => { k = (k + 1) % terms.length; sph.textContent = GHt('Suche „{t}“', { t: terms[k] }); }, 3500); }

  /* predictive search */
  (function () {
    const q = $('#gh-q'), res = $('#gh-srch-res'), resH = $('#gh-srch-h'), pop = $('#gh-srch-pop'), clr = $('#gh-q-clr');
    if (!q || !res) return;
    const def = res.innerHTML, base = (window.GH && GH.searchUrl) || '/search';
    let t, seq = 0;
    async function suggest(s) {
      s = s.trim(); if (clr) clr.hidden = !s; if (pop) pop.hidden = !!s;
      if (!s) { res.innerHTML = def; if (resH) resH.textContent = GHt('Bestseller'); return; }
      const my = ++seq;
      try {
        const r = await fetch(`${base}/suggest.json?q=${encodeURIComponent(s)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,vendor`, { headers: { Accept: 'application/json' } });
        const j = await r.json(); if (my !== seq) return;
        const ps = (j.resources && j.resources.results && j.resources.results.products) || [];
        if (resH) resH.textContent = ps.length ? GHt('Produkte ({n})', { n: ps.length }) : GHt('Produkte');
        const re = new RegExp('(' + s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        const hl = x => esc(x).replace(re, '<mark>$1</mark>');
        res.innerHTML = ps.length
          ? ps.map(p => `<a href="${p.url}">${p.image ? `<img src="${p.image.replace(/(\.[a-z]+)(\?|$)/i, '_128x$1$2')}" alt="">` : '<span></span>'}<div><strong>${hl(p.title.split(' - ')[0])}</strong><span>${esc(p.type || '')}</span></div><b class="gh-num">${p.price ? fmt(Math.round(parseFloat(p.price) * 100)) : ''}</b></a>`).join('') + `<a class="gh-srch__all" href="${base}?q=${encodeURIComponent(s)}&type=product">${GHt('Alle Ergebnisse für „{q}“', { q: esc(s) })} →</a>`
          : `<p class="gh-srch__none">${GHt('Nichts gefunden für „{q}“. Tipp: Gerät eingeben, z. B. „iPhone 17“.', { q: esc(s) })}</p>`;
      } catch (e) {}
    }
    q.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => suggest(q.value), 180); });
    clr && clr.addEventListener('click', () => { q.value = ''; suggest(''); q.focus(); });
    document.addEventListener('click', e => { const b = e.target.closest('[data-q]'); if (!b) return; e.preventDefault(); q.value = b.dataset.q; suggest(q.value); q.focus(); });
    if (q.value) suggest(q.value);
  })();

  /* ---------- storage: cookie first, localStorage as mirror ---------- */
  const cookie = {
    get(n) { const m = document.cookie.match(new RegExp('(?:^|; )' + n.replace(/[.$?*|{}()\[\]\\\/+^]/g, '\\$&') + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; },
    set(n, v, days) { document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=' + Math.round(days * 86400) + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); }
  };
  const store = {
    get(k) { let v = cookie.get(k); if (v == null) { try { v = localStorage.getItem(k); } catch (e) {} } if (!v) return null; try { return JSON.parse(v); } catch (e) { return null; } },
    set(k, o, days) { const s = JSON.stringify(o); cookie.set(k, s, days); try { localStorage.setItem(k, s); } catch (e) {} }
  };

  /* ---------- cookie consent (own, app-free; feeds Shopify Customer Privacy API + Google Consent Mode) ---------- */
  const consent = (function () {
    const el = $('#gh-ck'), KEY = 'gh_consent', DAYS = el ? (+el.dataset.days || 365) : 365;
    let cur = store.get(KEY), ready = false, hideT; const q = [];
    const decided = () => { if (ready) return; ready = true; q.splice(0).forEach(f => { try { f(); } catch (e) {} }); };
    const withApi = fn => {
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) return fn(Shopify.customerPrivacy);
      if (window.Shopify && typeof Shopify.loadFeatures === 'function') { try { return Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], err => fn(!err && Shopify.customerPrivacy ? Shopify.customerPrivacy : null)); } catch (e) {} }
      fn(null);
    };
    const yes = v => v === 'yes' || v === true;
    const push = (api, c) => { try { api.setTrackingConsent({ analytics: !!c.a, marketing: !!c.m, preferences: !!c.p, sale_of_data: !!c.m }, () => {}); } catch (e) {} };
    /* Eigener Traffic: ?gh_intern=1 setzt Cookie + localStorage (400 Tage), ?gh_intern=0 hebt auf. Interne Besuche senden weder Shopify-Analytics noch Google-Signale (Einwilligung bleibt „abgelehnt“, kein Banner). */
    const internal = (function () {
      const qs = new URLSearchParams(location.search).get('gh_intern');
      if (qs === '1') { cookie.set('gh_internal', '1', 400); try { localStorage.setItem('gh_internal', '1'); } catch (e) {} }
      else if (qs === '0') { cookie.set('gh_internal', '', -1); try { localStorage.removeItem('gh_internal'); } catch (e) {} }
      let on = cookie.get('gh_internal') === '1'; if (!on) { try { on = localStorage.getItem('gh_internal') === '1'; } catch (e) {} }
      if (on) window.GHinternal = true;
      return on && qs !== '0';
    })();
    const apply = (c, force) => {
      if (internal) c = { v: 1, a: 0, m: 0, p: c.p ? 1 : 0, t: c.t };
      withApi(api => { if (!api) return; let s = null; try { s = api.currentVisitorConsent(); } catch (e) {} if (force || !s || yes(s.analytics) !== !!c.a || yes(s.marketing) !== !!c.m || yes(s.preferences) !== !!c.p) push(api, c); });
      window.dataLayer = window.dataLayer || [];
      const g = { analytics_storage: c.a ? 'granted' : 'denied', ad_storage: c.m ? 'granted' : 'denied', ad_user_data: c.m ? 'granted' : 'denied', ad_personalization: c.m ? 'granted' : 'denied', functionality_storage: c.p ? 'granted' : 'denied', personalization_storage: c.p ? 'granted' : 'denied' };
      (typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); })('consent', 'update', g);
      window.dataLayer.push({ event: 'gh_consent', consent_analytics: !!c.a, consent_marketing: !!c.m, consent_preferences: !!c.p });
      document.dispatchEvent(new CustomEvent('gh:consent', { detail: c }));
    };
    const save = (c, force) => { cur = { v: 1, a: c.a ? 1 : 0, m: c.m ? 1 : 0, p: c.p ? 1 : 0, t: Date.now() }; store.set(KEY, cur, DAYS); apply(cur, force); };
    const show = view => {
      if (!el) return; clearTimeout(hideT); el.classList.remove('is-leaving');
      const prefs = view === 'prefs';
      $('.gh-ck__main', el).classList.toggle('gh-hidden', prefs);
      $('.gh-ck__prefs', el).classList.toggle('gh-hidden', !prefs);
      if (prefs) $$('input[data-cat]', el).forEach(i => { i.checked = !!(cur && cur[i.dataset.cat]); });
      el.classList.remove('gh-hidden');
    };
    const hide = () => { if (!el || el.classList.contains('gh-hidden')) return; el.classList.add('is-leaving'); hideT = setTimeout(() => { el.classList.add('gh-hidden'); el.classList.remove('is-leaving'); }, 260); };
    const choose = c => { save(c, true); hide(); decided(); };
    if (el) el.addEventListener('click', e => {
      const b = e.target.closest('[data-ck]'); if (!b) return;
      const a = b.dataset.ck;
      if (a === 'accept') choose({ a: 1, m: 1, p: 1 });
      else if (a === 'reject') choose({ a: 0, m: 0, p: 0 });
      else if (a === 'close') { if (cur) hide(); else choose({ a: 0, m: 0, p: 0 }); }
      else if (a === 'settings') show('prefs');
      else if (a === 'back') show('main');
      else if (a === 'save') { const o = {}; $$('input[data-cat]', el).forEach(i => { o[i.dataset.cat] = i.checked ? 1 : 0; }); choose(o); }
    });
    if (!el) decided();
    else if (internal) { apply(cur || { a: 0, m: 0, p: 0 }, true); decided(); }
    else if (cur) { apply(cur, false); decided(); }
    else {
      let done = false;
      const go = api => {
        if (done) return; done = true;
        if (api) { try { const s = api.currentVisitorConsent(); if (s && (s.analytics || s.marketing || s.preferences)) { save({ a: yes(s.analytics), m: yes(s.marketing), p: yes(s.preferences) }, false); decided(); return; } } catch (e) {} }
        show('main');
      };
      withApi(go); setTimeout(() => go(null), 1500);
    }
    return { get: () => cur, open: () => show(cur ? 'prefs' : 'main'), onReady: f => { ready ? f() : q.push(f); } };
  })();
  window.GHconsent = consent;
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="cookie-einstellungen"],[data-ck-open]');
    if (!a) return;
    e.preventDefault();
    if ($('#gh-ck')) consent.open();
    else if (window.privacyBanner && privacyBanner.showPreferences) privacyBanner.showPreferences();
    else if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.showPreferences) Shopify.customerPrivacy.showPreferences();
  });

  /* ---------- newsletter popup (own) ---------- */
  (function () {
    const pop = $('#gh-popup'); if (!pop) return;
    const KEY = 'gh_news';
    let state = store.get(KEY); if (!state) { try { state = JSON.parse(localStorage.getItem('gh-news') || 'null'); } catch (e) {} } state = state || {};
    const save = o => { state = Object.assign(state, o); store.set(KEY, state, 365); };
    const params = new URLSearchParams(location.search);
    if (params.get('customer_posted') === 'true' || params.get('gh_news') === '1') {
      save({ done: true, t: Date.now() });
      const t = $('#gh-news-toast'); if (t) { t.classList.remove('gh-hidden'); setTimeout(() => t.classList.add('gh-hidden'), 6000); }
      if (history.replaceState) { const u = new URL(location.href); u.searchParams.delete('gh_news'); u.searchParams.delete('customer_posted'); u.hash = ''; history.replaceState({}, '', u); }
      return;
    }
    /* Merken wie beim Cookie-Banner: angemeldet (done) oder „Nein danke“ (declined) = ein Jahr Ruhe;
       X/Scrim/Escape oder einfach weiternavigiert (closed/seen) = Cooldown-Tage aus der Sektion. */
    const days = +pop.dataset.days || 14, now = Date.now();
    if (state.done || (state.declined && now - state.declined < 365 * 864e5)) return;
    const last = Math.max(+state.closed || 0, +state.seen || 0);
    if (last && now - last < days * 864e5) return;
    let shown = false;
    const blocked = () => ['#gh-cart', '#gh-ck', '#gh-added', '#gh-drawer', '#gh-search'].some(s => { const x = $(s); return x && !x.classList.contains('gh-hidden'); });
    const open = () => { if (shown || blocked()) return; shown = true; save({ seen: Date.now() }); pop.classList.remove('gh-hidden'); document.body.style.overflow = 'hidden'; const i = pop.querySelector('input[type=email]'); if (i && window.matchMedia('(min-width: 641px)').matches) setTimeout(() => i.focus(), 300); };
    const close = declined => { pop.classList.add('gh-hidden'); document.body.style.overflow = ''; save(declined ? { declined: Date.now() } : { closed: Date.now() }); };
    pop.addEventListener('click', e => { const b = e.target.closest('[data-popup-close]'); if (b) close(b.classList.contains('gh-popup__no')); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !pop.classList.contains('gh-hidden')) close(false); });
    pop.querySelector('form').addEventListener('submit', () => save({ done: true, t: Date.now() }));
    consent.onReady(() => {
      setTimeout(open, (+pop.dataset.delay || 12) * 1000);
      const pct = +pop.dataset.scroll || 45;
      window.addEventListener('scroll', () => { const h = document.documentElement.scrollHeight - innerHeight; if (h > 0 && scrollY / h * 100 >= pct) open(); }, { passive: true });
      if (pop.dataset.exit === 'true') document.addEventListener('mouseleave', e => { if (e.clientY <= 0) open(); });
    });
  })();

  /* ---------- dark mode: Umschalter, Cookie, einmaliger Hinweis ---------- */
  (function () {
    const KEY = 'gh_theme', root = document.documentElement, btn = $('#gh-theme');
    const apply = t => { if (t === 'dark') root.setAttribute('data-gh-theme', 'dark'); else root.removeAttribute('data-gh-theme'); if (btn) { btn.setAttribute('aria-pressed', String(t === 'dark')); btn.setAttribute('aria-label', t === 'dark' ? GHt('Helles Design einschalten') : GHt('Dunkles Design einschalten')); } };
    const save = (t, asked) => { store.set(KEY, { t, asked: asked ? 1 : 0, ts: Date.now() }, 365); try { localStorage.setItem('gh-theme', t); } catch (e) {} };
    let st = store.get(KEY); if (!st) { let ls = null; try { ls = localStorage.getItem('gh-theme'); } catch (e) {} if (ls) st = { t: ls, asked: 1 }; }
    apply(st ? (st.t === 'dark' ? 'dark' : 'light') : (root.dataset.ghDefault === 'dark' ? 'dark' : 'light'));
    const prompt = $('#gh-tprompt');
    const hidePrompt = () => { if (!prompt || prompt.hidden) return; prompt.classList.add('is-out'); setTimeout(() => { prompt.hidden = true; prompt.classList.remove('is-out'); }, reduce ? 0 : 220); };
    btn && btn.addEventListener('click', () => { const t = root.getAttribute('data-gh-theme') === 'dark' ? 'light' : 'dark'; apply(t); save(t, true); hidePrompt(); });
    if (prompt && !(st && (st.asked || st.t === 'dark'))) {
      const show = () => { if (['#gh-cart', '#gh-ck', '#gh-added', '#gh-drawer', '#gh-search', '#gh-popup'].some(s => { const x = $(s); return x && !x.classList.contains('gh-hidden'); })) { setTimeout(show, 2000); return; } prompt.hidden = false; clearTimeout(prompt.__t); prompt.__t = setTimeout(() => { if (!prompt.hidden) { save('light', true); hidePrompt(); } }, 20000); };
      consent.onReady(() => setTimeout(show, 5000));
      prompt.addEventListener('click', e => { const c = e.target.closest('[data-theme-choice]'); if (c) { const t = c.dataset.themeChoice; apply(t); save(t, true); hidePrompt(); return; } if (e.target.closest('[data-tprompt-close]')) { save('light', true); hidePrompt(); } });
    }
  })();

  /* ---------- accordion: only one open (fallback for browsers without <details name>) ---------- */
  document.addEventListener('toggle', e => {
    const d = e.target; if (!(d instanceof HTMLDetailsElement) || !d.open || !d.getAttribute('name')) return;
    $$('details[name="' + d.getAttribute('name') + '"][open]').forEach(o => { if (o !== d) o.open = false; });
  }, true);

  /* ---------- Versandlogik: deutsche Zeit, Wochenende, Feiertage (bundesweit + Niedersachsen), eigene Schließtage ---------- */
  const GHship = (() => {
    const pad = n => String(n).padStart(2, '0');
    const key = d => d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    const berlin = () => { const p = {}; try { new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach(x => { p[x.type] = +x.value; }); } catch (e) { const n = new Date(); return { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate(), hour: n.getHours(), minute: n.getMinutes() }; } return p; };
    const easter = y => { const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1; return new Date(y, mo - 1, da); };
    const cache = {};
    const holidays = y => {
      if (cache[y]) return cache[y];
      const e = easter(y), off = n => { const d = new Date(e); d.setDate(d.getDate() + n); return key(d); };
      const m = { [y + '-01-01']: 'Neujahr', [off(-2)]: 'Karfreitag', [off(1)]: 'Ostermontag', [y + '-05-01']: 'Tag der Arbeit', [off(39)]: 'Christi Himmelfahrt', [off(50)]: 'Pfingstmontag', [y + '-10-03']: 'Tag der Deutschen Einheit', [y + '-10-31']: 'Reformationstag', [y + '-12-25']: '1. Weihnachtstag', [y + '-12-26']: '2. Weihnachtstag' };
      return (cache[y] = m);
    };
    /* Schließtage aus den Header-Einstellungen: „24.12.2026“, „24.12.“ (jedes Jahr) oder „2026-12-24“, optional „von–bis“ */
    const closed = () => {
      const out = { fixed: new Set(), yearly: new Set() };
      const one = s => { let m; if ((m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s))) return { k: s }; if ((m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(s))) return { k: m[3] + '-' + pad(m[2]) + '-' + pad(m[1]) }; if ((m = /^(\d{1,2})\.(\d{1,2})\.?$/.exec(s))) return { y: pad(m[2]) + '-' + pad(m[1]) }; return null; };
      ((window.GH || {}).closedDays || []).forEach(raw => {
        String(raw).split(/[;,]/).forEach(part => {
          const s = part.trim(); if (!s) return;
          const range = s.split(/\s*(?:–|-{1,2}|bis)\s*(?=\d{1,2}\.)/);
          if (range.length === 2 && one(range[0]) && one(range[1]) && one(range[0]).k && one(range[1]).k) {
            const a = new Date(one(range[0]).k + 'T00:00:00'), b = new Date(one(range[1]).k + 'T00:00:00');
            for (let d = new Date(a), n = 0; d <= b && n < 60; d.setDate(d.getDate() + 1), n++) out.fixed.add(key(d));
            return;
          }
          const o = one(s); if (!o) return; if (o.k) out.fixed.add(o.k); else out.yearly.add(o.y);
        });
      });
      return out;
    };
    let cl = null;
    const why = d => { const wd = d.getDay(); if (wd === 0 || wd === 6) return GHt('Wochenende'); const h = holidays(d.getFullYear())[key(d)]; if (h) return GHt(h); cl = cl || closed(); if (cl.fixed.has(key(d)) || cl.yearly.has(key(d).slice(5))) return GHt('Betriebsruhe'); return ''; };
    const biz = d => !why(d);
    const add = (d, n) => { const r = new Date(d); let k = 0; while (k < n) { r.setDate(r.getDate() + 1); if (biz(r)) k++; } return r; };
    const fmt = d => d.toLocaleDateString(GHloc, { weekday: 'short', day: 'numeric', month: 'numeric' });
    const plan = o => {
      o = o || {}; const g = window.GH || {};
      const cutoff = +(o.cutoff || g.cutoffHour) || 10, minD = +(o.minDays || g.minDays) || 2, maxD = +(o.maxDays || g.maxDays) || 3;
      const b = berlin(), today = new Date(b.year, b.month - 1, b.day);
      const reasonToday = why(today), sameDay = !reasonToday && b.hour < cutoff;
      let ship = new Date(today); if (!sameDay) { do { ship.setDate(ship.getDate() + 1); } while (!biz(ship)); }
      const gap = Math.round((ship - today) / 864e5);
      return { cutoff, sameDay, today, ship, gap, earliest: add(ship, minD), latest: add(ship, maxD), minsLeft: sameDay ? cutoff * 60 - (b.hour * 60 + b.minute) : 0, reason: sameDay ? '' : (reasonToday || GHt('nach {h} Uhr', { h: cutoff })) };
    };
    /* Kurztext für Balken und Trust-Zeilen */
    const line = (p, withCountdown) => {
      if (p.sameDay) { const h = Math.floor(p.minsLeft / 60), m = p.minsLeft % 60; return GHt('Bis {h} Uhr bestellt, heute verschickt', { h: p.cutoff }) + (withCountdown ? ' · ' + GHt('noch {t}', { t: (h ? h + ' ' + GHt('Std.') + ' ' : '') + m + ' ' + GHt('Min.') }) : ''); }
      return p.gap === 1 ? GHt('Jetzt bestellt, morgen verschickt') : GHt('Jetzt bestellt, Versand am {d}', { d: fmt(p.ship) });
    };
    return { plan, line, fmt, biz, why };
  })();
  window.GHship = GHship;
  /* Balken ([data-gh-ship]) und feste Texte „Bis 10 Uhr bestellt, heute verschickt“ an den echten Versandtag anpassen */
  (function shipTexts() {
    const paint = () => { const p = GHship.plan(); $$('[data-gh-ship]').forEach(el => { el.textContent = GHship.line(p, el.hasAttribute('data-gh-ship-count')); }); return p; };
    const p = paint();
    if (!p.sameDay) {
      const re = new RegExp(GHt('Bis \\d{1,2} Uhr bestellt, heute verschickt'), 'g'), txt = GHship.line(p, false);
      const w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, { acceptNode: n => (re.lastIndex = 0, re.test(n.nodeValue) && !(n.parentElement && n.parentElement.closest('script,style,[data-gh-ship]')) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT) });
      const nodes = []; while (w.nextNode()) nodes.push(w.currentNode);
      nodes.forEach(n => { re.lastIndex = 0; n.nodeValue = n.nodeValue.replace(re, txt); });
    }
    setInterval(paint, 60000);
  })();

  /* ---------- Balken: Menüs (Land/Währung, Sendungsverfolgung) ---------- */
  document.addEventListener('click', e => { $$('[data-gh-anndd][open]').forEach(d => { if (!d.contains(e.target)) d.open = false; }); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('[data-gh-anndd][open]').forEach(d => { d.open = false; }); });
  document.addEventListener('toggle', e => { const d = e.target; if (d.matches && d.matches('[data-gh-anndd]') && d.open) { $$('[data-gh-anndd][open]').forEach(o => { if (o !== d) o.open = false; }); const i = d.querySelector('input'); if (i) i.focus(); } }, true);
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-gh-track]'); if (!f) return;
    e.preventDefault();
    const nr = (f.querySelector('input').value || '').replace(/\s+/g, ''); if (!nr) return;
    window.open((f.dataset.ghTrack || '').replace('[nr]', encodeURIComponent(nr)), '_blank', 'noopener');
  });

  /* ---------- own cart drawer ---------- */
  const G = window.GH || {};
  function deliveryWindow() {
    const p = GHship.plan(), f = d => d.toLocaleDateString(GHloc, { weekday: 'short', day: 'numeric', month: 'short' });
    const a = f(p.earliest), b = f(p.latest);
    return { text: a === b ? a : a + ' – ' + b, shipText: p.sameDay ? GHt('Versand heute bei Bestellung bis {h} Uhr', { h: p.cutoff }) : GHt('Versand am {d}', { d: GHship.fmt(p.ship) }) };
  }
  const cart = {
    el: $('#gh-cart'), scrim: $('#gh-cart-scrim'), threshold: +(G.freeShipping || 0), gift: +(G.gift || 0), shipCost: +(G.shipCost || 0),
    last: null, products: {}, loading: {}, codeOpen: false, addedT: null, lastPct: null,
    open() { if (!this.el) return; this.openedAt = Date.now(); openLayer('cart'); this.animateBar(300); },
    animateBar(delay) { const fill = $('.gh-ms__fill', this.el); if (!fill) return; const w = +fill.dataset.w; fill.style.transition = 'none'; fill.style.width = '0%'; void fill.offsetWidth; fill.style.transition = ''; clearTimeout(this.barT); this.barT = setTimeout(() => { fill.style.width = w + '%'; }, delay); },
    close() { closeLayers(); },
    async refresh() { const body = $('#gh-cart-body'); if (body && !this.last) body.innerHTML = '<div class="gh-loading"><span class="gh-spin gh-spin--dark"></span></div>'; try { const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); this.render(c); return c; } catch (e) { return null; } },
    count(n, total) {
      const b = $('#cart-icon-bubble'); if (!b) return;
      const ico = b.querySelector('.gh-hdr__cartico') || b;
      let c = ico.querySelector('.gh-ibtn__count');
      if (n > 0) { if (!c) { c = document.createElement('span'); c.className = 'gh-ibtn__count'; ico.appendChild(c); } if (c.textContent !== String(n)) { c.textContent = n; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); } }
      else if (c) c.remove();
      const s = $('#gh-cart-hsum'); if (s) { s.hidden = !n; s.textContent = fmt(total || 0); }
    },
    added(title) {
      const a = $('#gh-cart-added'); if (!a) return;
      a.querySelector('span').textContent = GHt('{title} hinzugefügt', { title }); a.classList.add('is-on');
      clearTimeout(this.addedT); this.addedT = setTimeout(() => a.classList.remove('is-on'), 3200);
      const body = $('#gh-cart-body'); if (body) body.scrollTop = 0;
    },
    upsellCards(handles, limit) {
      const tpl = $('#gh-cart-ups-tpl'); if (!tpl) return '';
      const wrap = document.createElement('div'); wrap.innerHTML = tpl.innerHTML;
      return $$('.gh-up', wrap).filter(u => !u.hidden && !handles.includes(u.dataset.handle)).slice(0, limit).map(u => u.outerHTML).join('');
    },
    milestones(total) {
      const free = this.threshold, gift = this.gift > free ? this.gift : 0, end = gift || free;
      if (!free) return '';
      const pct = Math.min(100, total / end * 100);
      /* kurz vor der nächsten Stufe: letztes Viertel des Abschnitts, mindestens 5 € */
      const next = total < free ? free : (gift && total < gift ? gift : 0), segStart = next === gift ? free : 0;
      const near = !!next && (next - total) <= Math.max(500, (next - segStart) * 0.25);
      let msg;
      if (total < free) msg = GHt(near ? 'Nur noch {a} bis zum kostenlosen Versand' : 'Noch {a} bis zum kostenlosen Versand', { a: `<b class="gh-num">${fmt(free - total)}</b>` });
      else if (gift && total < gift) msg = `<span class="is-ok">${GHt('Gratisversand ist drin.')}</span> ` + GHt(near ? 'Nur noch {a} bis zu: {g}' : 'Noch {a} bis zu: {g}', { a: `<b class="gh-num">${fmt(gift - total)}</b>`, g: esc(G.giftLabel || 'Extra') });
      else if (gift) msg = `<span class="is-ok">${GHt('Gratisversand und {g} sind drin.', { g: esc(G.giftLabel || 'Extra') })}</span>`;
      else msg = `<span class="is-ok">${GHt('Kostenloser Versand ist drin ✓')}</span>`;
      const pts = gift
        ? `<div class="gh-ms__pt gh-ms__pt--mid${total >= free ? ' is-hit' : (near && next === free ? ' is-next' : '')}" style="left:${free / gift * 100}%"><i></i><span>${GHt('Gratisversand {a}', { a: fmt(free).replace(',00', '') })}</span></div><div class="gh-ms__pt gh-ms__pt--end${total >= gift ? ' is-hit' : (near && next === gift ? ' is-next' : '')}" style="left:100%"><i></i><span>${esc(G.giftLabel || 'Extra')} ${fmt(gift).replace(',00', '')}</span></div>`
        : `<div class="gh-ms__pt${total >= free ? ' is-hit' : (near ? ' is-next' : '')}" style="left:100%"><i></i><span>${GHt('Gratisversand {a}', { a: fmt(free).replace(',00', '') })}</span></div>`;
      return `<div class="gh-cart__ms"><p>${msg}</p><div class="gh-ms${gift ? '' : ' gh-ms--single'}${near ? ' is-near' : ''}"><i class="gh-ms__track"></i><i class="gh-ms__fill${total >= end ? ' is-done' : ''}" data-w="${pct}" style="width:${this.lastPct != null ? this.lastPct : 0}%"></i>${pts}</div></div>`;
    },
    item(i, dw) {
      const prod = this.products[i.handle], v = prod && prod.variants.find(x => x.id === i.variant_id);
      const cmp = v && v.compare_at_price && v.compare_at_price > i.final_price ? v.compare_at_price * i.quantity : 0;
      const was = Math.max(cmp, i.original_line_price > i.final_line_price ? i.original_line_price : 0);
      const pack = +G.pack2Off > 0 && i.quantity === 1 && i.final_price > +G.pack2Off;
      return `<div class="gh-cart__item" data-key="${i.key}" data-handle="${esc(i.handle)}">
        <a href="${i.url}" class="gh-cart__img">${i.image ? `<img src="${i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="">` : ''}</a>
        <div class="gh-cart__info">
          <a href="${i.url}" class="gh-cart__title">${esc(i.product_title.split(' - ')[0])}</a>
          ${i.variant_title && i.variant_title !== 'Default Title' ? `<span class="gh-cart__var">${esc(i.variant_title)}</span>` : ''}
          <span class="gh-cart__stock"><b>${GHt('Auf Lager')}</b> · ${dw.shipText}</span>
          <div class="gh-cart__row">
            <div class="gh-qty"><button type="button" data-qty="-1" aria-label="${GHt('Weniger')}">−</button><span class="gh-num">${i.quantity}</span><button type="button" data-qty="1" aria-label="${GHt('Mehr')}">+</button></div>
            <div class="gh-cart__pr"><b class="gh-num">${fmt(i.final_line_price)}</b>${was > i.final_line_price ? `<s class="gh-num">${fmt(was)}</s> <em class="gh-num">−${fmt(was - i.final_line_price)}</em>` : ''}</div>
            <button type="button" class="gh-cart__rm" data-rm aria-label="${GHt('Entfernen')}"><svg class="gh-ico"><use href="#gh-i-trash"/></svg></button>
          </div>
        </div>
        ${pack ? `<div class="gh-cart__pack"><span>${GHt('2. Stück nur {p} · spare {s}', { p: `<b class="gh-num">${fmt(i.final_price - G.pack2Off)}</b>`, s: fmt(G.pack2Off) })}</span><button type="button" data-qty="1">${GHt('+ 1 dazu')}</button></div>` : ''}
      </div>`;
    },
    render(c) {
      if (!this.el || !c) return;
      this.last = c;
      const body = $('#gh-cart-body'), foot = $('#gh-cart-foot'); if (!body) return;
      const scroll = body.scrollTop;
      const n = c.item_count, total = c.total_price;
      this.count(n, total);
      $('#gh-cart-n').textContent = n ? `(${n})` : '';
      if (!c.items.length) {
        const chips = (G.menuChips || []).slice(0, 6).map(m => `<a class="gh-cchip" href="${m.u}">${esc(m.t)}</a>`).join('');
        const best = this.upsellCards([], 2);
        body.innerHTML = `<div class="gh-cart__empty"><div class="gh-cart__emptyico"><svg class="gh-ico"><use href="#gh-i-cart"/></svg></div><h4>${GHt('Dein Warenkorb ist leer')}</h4><p>${GHt('Lass dich inspirieren: das kaufen andere gerade.')}</p>${best ? `<h5>${GHt('Bestseller')}</h5><div class="gh-cart__best">${best}</div>` : ''}${chips ? `<h5>${GHt('Kategorien')}</h5><div class="gh-chiprow gh-chiprow--wrap gh-chiprow--center">${chips}</div>` : ''}</div>`;
        if (foot) foot.hidden = true;
        return;
      }
      const dw = deliveryWindow();
      const handles = c.items.map(i => i.handle);
      const ship = this.threshold && total >= this.threshold ? 0 : this.shipCost;
      const codes = (c.discount_codes || []).filter(d => d.applicable);
      const ups = this.upsellCards(handles, 4);
      body.innerHTML = this.milestones(total)
        + `<div class="gh-cart__items">${c.items.map(i => this.item(i, dw)).join('')}</div>`
        + (ups ? `<div class="gh-cart__ups"><h4>${GHt('Dazu passt')} <span>${GHt('Ein Klick, keine Variantenwahl')}</span><span class="gh-ups__nav"><button type="button" data-ups="-1" aria-label="${GHt('Zurück')}"><svg class="gh-ico"><use href="#gh-i-left"/></svg></button><button type="button" data-ups="1" aria-label="${GHt('Weiter')}"><svg class="gh-ico"><use href="#gh-i-right"/></svg></button></span></h4><div class="gh-ups">${ups}</div></div>` : '')
        + `<details class="gh-cart__code"${this.codeOpen || codes.length ? ' open' : ''}><summary>${GHt('Gutschein einlösen')} <svg class="gh-ico"><use href="#gh-i-chev"/></svg></summary>${codes.length ? `<div class="gh-cart__codes">${codes.map(d => `<span>${esc(d.code)} <button type="button" data-code-rm="${esc(d.code)}" aria-label="${GHt('Code entfernen')}"><svg class="gh-ico"><use href="#gh-i-x"/></svg></button></span>`).join('')}</div>` : ''}<div class="gh-cart__codef"><input type="text" id="gh-code" placeholder="Code" aria-label="${GHt('Gutschein-Code')}" autocomplete="off"><button type="button" data-code-apply>${GHt('Einlösen')}</button></div><p class="gh-cart__codemsg" id="gh-code-msg"></p></details>`
        + `<div class="gh-cart__sum">
            <div class="gh-cart__subt"><span>${GHt('Zwischensumme')}</span><span class="gh-num">${fmt(c.original_total_price)}</span></div>
            ${c.total_discount ? `<div class="gh-cart__disc"><span>${GHt('Du sparst')}</span><span class="gh-num">${fmt(c.total_discount)}</span></div>` : ''}
            ${this.threshold || this.shipCost ? `<div class="gh-cart__ship"><span>${GHt('Versand')}</span><span>${ship ? `<span class="gh-num">${fmt(ship)}</span>` : `${this.shipCost ? `<s class="gh-num">${fmt(this.shipCost)}</s>` : ''}<b>${GHt('Kostenlos')}</b>`}</span></div>` : ''}
            <div class="gh-cart__del"><span>${GHt('Lieferung voraussichtlich')}</span><span>${dw.text}</span></div>
            ${G.b2bUrl ? `<span class="gh-cart__b2b">${GHt('Firmenkunde? {a}Rechnung mit USt-ID{b} an der Kasse.', { a: `<a href="${G.b2bUrl}">`, b: '</a>' })}</span>` : ''}
          </div>`;
      body.scrollTop = scroll;
      upsDots($('.gh-ups', body));
      const fill = $('.gh-ms__fill', body); if (fill) { const w = +fill.dataset.w; const since = Date.now() - (this.openedAt || 0); if (this.el.classList.contains('gh-hidden') || this.lastPct == null || since < 1500) this.animateBar(Math.max(60, 300 - since)); else requestAnimationFrame(() => requestAnimationFrame(() => { fill.style.width = w + '%'; })); this.lastPct = w; }
      const grand = total + ship;
      $('#gh-cart-tot').textContent = fmt(grand); $('#gh-cart-tot2').textContent = fmt(grand);
      const note = $('#gh-cart-totnote'); if (note) note.textContent = ship ? GHt('inkl. MwSt. und Versand') : GHt('inkl. MwSt.');
      if (foot) foot.hidden = false;
      /* compare-at prices come from the product JSON, fetched once per product */
      const missing = handles.filter((h, k) => handles.indexOf(h) === k && !this.products[h] && !this.loading[h]);
      if (missing.length) Promise.all(missing.map(h => { this.loading[h] = true; return fetch(`/products/${h}.js`).then(r => r.json()).then(p => { this.products[h] = p; }).catch(() => { this.products[h] = { variants: [] }; }); })).then(() => { if (this.last === c) this.render(c); });
    },
    async add(formData, opts = {}) {
      const r = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const j = await r.json();
      if (j.status || j.errors) throw new Error(j.description || j.message || GHt('Konnte nicht hinzugefügt werden.'));
      const item = (j.items ? j.items[0] : j) || {};
      if (opts.popup) {
        const cP = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).catch(() => null);
        await new Promise(res => flyToCart(opts.from, res, opts.img));
        const c = await cP; if (c) this.render(c);
        this.showAdded(item, c);
      } else if (!opts.silent) { await this.refresh(); this.open(); if (item.product_title) this.added(item.product_title.split(' - ')[0]); }
      return j;
    },
    showAdded(item, c) {
      const pop = $('#gh-added'); if (!pop || !item) { this.open(); return; }
      const handles = c ? c.items.map(i => i.handle) : [item.handle];
      $('#gh-added-item').innerHTML = `<div class="gh-added__row"><img src="${(item.image || '').replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt=""><div><strong>${esc(item.product_title.split(' - ')[0])}</strong>${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${esc(item.variant_title)}</span>` : ''}<span>${item.quantity} × <b class="gh-num">${fmt(item.final_price)}</b></span></div></div>`;
      const ups = this.upsellCards(handles, 5), uw = $('#gh-added-ups-wrap');
      const us = $('#gh-added-ups'); us.innerHTML = ups; us.scrollLeft = 0; if (uw) uw.hidden = !ups; upsDots(us);
      const n = c ? c.item_count : item.quantity, tot = c ? c.total_price : item.final_line_price;
      const ship = this.threshold && tot >= this.threshold ? 0 : this.shipCost;
      $('#gh-added-n').textContent = n ? `(${n})` : ''; $('#gh-added-tot').textContent = fmt(tot + ship);
      if (pop.classList.contains('gh-hidden')) openLayer('added');
      pop.scrollTop = 0; upsDots(us);
    },
    async change(key, qty) {
      const row = this.el && this.el.querySelector('.gh-cart__item[data-key="' + key + '"]'); row && row.classList.add('is-busy');
      const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      this.render(await r.json());
    },
    async code(list, msgOk) {
      const msg = $('#gh-code-msg');
      try {
        const r = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) });
        const j = await r.json();
        const want = list[list.length - 1], ok = (j.discount_codes || []).some(d => d.code.toLowerCase() === (want || '').toLowerCase() && d.applicable);
        this.codeOpen = true; this.render(j);
        const m = $('#gh-code-msg');
        if (!want) return;
        if (ok) { m.textContent = msgOk; m.classList.remove('is-err'); }
        else { m.textContent = GHt('Dieser Code ist ungültig oder passt nicht zu deinem Warenkorb.'); m.classList.add('is-err'); }
      } catch (e) { if (msg) { msg.textContent = GHt('Das hat nicht geklappt. Bitte gleich noch einmal versuchen.'); msg.classList.add('is-err'); } }
    }
  };
  if (cart.el) {
    $('#cart-icon-bubble') && $('#cart-icon-bubble').addEventListener('click', e => { e.preventDefault(); cart.open(); cart.refresh(); });
    cart.el.addEventListener('click', e => {
      if (e.target.closest('[data-cart-close]')) { cart.close(); return; }
      const ap = e.target.closest('[data-code-apply]');
      if (ap) { const inp = $('#gh-code'), v = (inp.value || '').trim(); if (!v) { inp.focus(); return; } const cur = ((cart.last && cart.last.discount_codes) || []).map(d => d.code); cart.code(cur.concat(v), GHt('Code eingelöst.')); return; }
      const rm = e.target.closest('[data-code-rm]');
      if (rm) { const cur = ((cart.last && cart.last.discount_codes) || []).map(d => d.code).filter(c => c.toLowerCase() !== rm.dataset.codeRm.toLowerCase()); cart.code(cur, ''); return; }
      const item = e.target.closest('.gh-cart__item'); if (!item) return;
      const key = item.dataset.key, cur = +$('.gh-qty span', item).textContent;
      if (e.target.closest('[data-rm]')) { cart.change(key, 0); return; }
      const qb = e.target.closest('[data-qty]');
      if (qb) {
        const next = Math.max(0, cur + (+qb.dataset.qty));
        if (next >= 2 && G.pack2Code && cur < 2) fetch('/discount/' + encodeURIComponent(G.pack2Code), { credentials: 'same-origin' }).catch(() => {});
        cart.change(key, next);
      }
    });
    cart.el.addEventListener('toggle', e => { if (e.target.classList.contains('gh-cart__code')) cart.codeOpen = e.target.open; }, true);
    cart.el.addEventListener('keydown', e => { if (e.key === 'Enter' && e.target.id === 'gh-code') { e.preventDefault(); $('[data-code-apply]', cart.el).click(); } });
    /* swipe down on the grip closes the sheet (mobile) */
    const grip = $('.gh-cart__grip', cart.el); let gy = null;
    if (grip) { grip.addEventListener('touchstart', e => { gy = e.touches[0].clientY; }, { passive: true }); grip.addEventListener('touchmove', e => { if (gy !== null && e.touches[0].clientY - gy > 60) { gy = null; cart.close(); } }, { passive: true }); }
    cart.el.addEventListener('touchstart', e => { if (e.target.closest('.gh-cart__head')) gy = e.touches[0].clientY; }, { passive: true });
    cart.el.addEventListener('touchmove', e => { if (gy !== null && e.target.closest('.gh-cart__head') && e.touches[0].clientY - gy > 70) { gy = null; cart.close(); } }, { passive: true });
  }
  window.GHcart = cart;

  /* ---------- quick add anywhere (cross-sell, cart upsells, empty state) ---------- */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-gh-add]'); if (!b || b.disabled || b.classList.contains('is-busy')) return;
    if (dragMoved) return;
    b.disabled = true; b.classList.add('is-busy');
    const fd = new FormData(); fd.append('id', b.dataset.ghAdd); fd.append('quantity', '1');
    try {
      if (b.closest('#gh-cart')) await cart.add(fd);
      else if (b.closest('#gh-added')) { const j = await cart.add(fd, { silent: true }); const c = await cart.refresh(); cart.showAdded(j.items ? j.items[0] : j, c); }
      else { const card = b.closest('.gh-up, [class*="__item"], [class*="card"], li, article'); const img = card && card.querySelector('img'); await cart.add(fd, { popup: true, from: innerWidth < 1024 ? b : (img || b), img }); }
      b.classList.add('is-ok');
    } catch (x) { alert(x.message); }
    b.disabled = false; b.classList.remove('is-busy');
  });

  /* ---------- product rows: arrows + position dots ---------- */
  function upsDots(s) {
    if (!s) return;
    let d = s.nextElementSibling; if (!d || !d.classList.contains('gh-ups__dots')) { d = document.createElement('div'); d.className = 'gh-ups__dots'; s.after(d); }
    const paint = () => {
      const cards = $$('.gh-up', s); if (cards.length < 2) { d.innerHTML = ''; return; }
      const step = (cards[1].offsetLeft - cards[0].offsetLeft) || 1;
      const atEnd = s.scrollLeft >= s.scrollWidth - s.clientWidth - 2;
      const i = atEnd ? cards.length - 1 : Math.max(0, Math.min(cards.length - 1, Math.round(s.scrollLeft / step)));
      d.innerHTML = cards.map((c, k) => `<button type="button" class="${k === i ? 'is-on' : ''}" data-dot="${k}" aria-label="${GHt('Produkt {n}', { n: k + 1 })}"></button>`).join('');
    };
    paint(); requestAnimationFrame(paint);
    if (!s.__dots) { s.__dots = true; let t; s.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(paint, 60); }, { passive: true }); }
  }
  document.addEventListener('click', e => {
    const un = e.target.closest('[data-ups]');
    if (un) { const w = un.closest('.gh-cart__ups, .gh-added__ups'); const s = w && w.querySelector('.gh-ups'); if (s) { const cards = $$('.gh-up', s); const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 170; s.scrollBy({ left: (+un.dataset.ups) * step, behavior: reduce ? 'auto' : 'smooth' }); } return; }
    const dot = e.target.closest('.gh-ups__dots [data-dot]');
    if (dot) { const s = dot.parentElement.previousElementSibling; const cards = $$('.gh-up', s); const c = cards[+dot.dataset.dot]; if (c) s.scrollTo({ left: c.offsetLeft - cards[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
  });

  /* ---------- fly-to-cart animation ---------- */
  const img0 = document.createElement('img');
  function flyToCart(src, done, imgEl) {
    const ico = $('.gh-hdr__cartico'); const hdrEl = $('#gh-header');
    if (!src || !ico || !src.getBoundingClientRect || !('animate' in img0)) { done && done(); return; }
    hdrEl && hdrEl.classList.remove('is-away');
    const s = src.getBoundingClientRect(); if (!s.width) { done && done(); return; }
    const t = ico.getBoundingClientRect();
    const size = Math.max(48, Math.min(s.width, s.height, 160));
    const img = document.createElement('img'); img.className = 'gh-fly'; img.alt = '';
    const pic = imgEl || (src.tagName === 'IMG' ? src : (src.querySelector && src.querySelector('img')));
    img.src = pic ? (pic.currentSrc || pic.src || '') : '';
    if (!img.src) { done && done(); return; }
    const sx = s.left + s.width / 2, sy = s.top + s.height / 2, tx = t.left + t.width / 2, ty = t.top + t.height / 2;
    Object.assign(img.style, { left: (sx - size / 2) + 'px', top: (sy - size / 2) + 'px', width: size + 'px', height: size + 'px' });
    document.body.appendChild(img);
    const dx = tx - sx, dy = ty - sy;
    const a = img.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '14px' },
      { transform: `translate(${dx * .45}px,${dy * .45 - 90}px) scale(.55)`, opacity: 1, offset: .55 },
      { transform: `translate(${dx}px,${dy}px) scale(.08)`, opacity: .5, borderRadius: '50%' }
    ], { duration: 1300, easing: 'cubic-bezier(.3,.6,.2,1)', fill: 'forwards' });
    a.onfinish = () => { img.remove(); done && done(); };
    setTimeout(() => { if (img.isConnected) { img.remove(); done && done(); done = null; } }, 1900);
  }

  /* ---------- drag-to-scroll for product rows (mouse) ---------- */
  let dragMoved = false;
  (function () {
    let el = null, sx = 0, sl = 0, moved = false;
    document.addEventListener('mousedown', e => { const s = e.target.closest('.gh-ups'); if (!s || e.button !== 0) return; el = s; sx = e.clientX; sl = s.scrollLeft; moved = false; s.classList.add('is-drag'); });
    document.addEventListener('mousemove', e => { if (!el) return; const dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; e.preventDefault(); } el.scrollLeft = sl - dx; });
    const end = () => { if (!el) return; el.classList.remove('is-drag'); el = null; dragMoved = moved; if (moved) setTimeout(() => { dragMoved = false; }, 50); };
    document.addEventListener('mouseup', end); document.addEventListener('mouseleave', end);
    document.addEventListener('click', e => { if (dragMoved && e.target.closest('.gh-ups')) { e.preventDefault(); e.stopPropagation(); } }, true);
  })();

  /* ---------- variant picker for cart upsells ---------- */
  (function () {
    if (!cart.el) return;
    let sheet = null, prod = null, sel = [];
    const vt = v => v.options.slice();
    const find = () => prod.variants.find(v => vt(v).every((t, i) => t === sel[i]));
    const availFor = (di, val) => prod.variants.some(v => v.available && vt(v).every((t, i) => i === di ? t === val : t === sel[i]));
    const close = () => { if (sheet) { sheet.remove(); sheet = null; } };
    function paint() {
      const v = find();
      $$('.gh-vsheet__pill', sheet).forEach(p => { const di = +p.dataset.opt; p.classList.toggle('is-on', sel[di] === p.dataset.val); p.classList.toggle('is-out', !availFor(di, p.dataset.val)); });
      const price = $('.gh-vsheet__price', sheet), btn = $('[data-vadd]', sheet), img = $('.gh-vsheet img', sheet);
      if (v) {
        price.innerHTML = `<b class="gh-num">${fmt(v.price)}</b>${v.compare_at_price > v.price ? ` <s class="gh-num">${fmt(v.compare_at_price)}</s>` : ''}`;
        btn.disabled = !v.available; btn.textContent = v.available ? GHt('In den Warenkorb') : GHt('Ausverkauft'); btn.dataset.vadd = v.id;
        if (img && v.featured_image && v.featured_image.src) img.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
      } else { price.textContent = ''; btn.disabled = true; btn.textContent = GHt('Nicht verfügbar'); }
    }
    function open(p) {
      close(); prod = p;
      const first = p.variants.find(v => v.available) || p.variants[0]; sel = vt(first);
      sheet = document.createElement('div'); sheet.className = 'gh-vsheet';
      sheet.innerHTML = `<div class="gh-vsheet__scrim" data-vclose></div><div class="gh-vsheet__box" role="dialog" aria-label="${GHt('Variante wählen')}">
        <div class="gh-vsheet__head"><img src="${(p.featured_image || '').replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt=""><div><strong>${esc(p.title.split(' - ')[0])}</strong><span class="gh-vsheet__price"></span></div><button type="button" class="gh-ibtn" data-vclose aria-label="${GHt('Schließen')}"><svg class="gh-ico"><use href="#gh-i-x"/></svg></button></div>
        <div class="gh-vsheet__body">${p.options.map((o, di) => `<h5>${esc(o.name)}</h5><div class="gh-vsheet__pills">${o.values.map(val => `<button type="button" class="gh-vsheet__pill" data-opt="${di}" data-val="${esc(val)}">${esc(val)}</button>`).join('')}</div>`).join('')}</div>
        <div class="gh-vsheet__foot"><button type="button" class="gh-btn gh-btn--cta" data-vadd>${GHt('In den Warenkorb')}</button></div></div>`;
      (host || cart.el).appendChild(sheet); paint();
    }
    let host = null;
    document.addEventListener('click', async e => {
      const h0 = e.target.closest('#gh-cart,#gh-added'); if (!h0) return;
      const pick = e.target.closest('[data-vpick]');
      if (pick) {
        e.preventDefault(); const h = pick.dataset.vpick;
        if (!cart.products[h]) { pick.disabled = true; pick.classList.add('is-busy'); try { cart.products[h] = await (await fetch(`/products/${h}.js`)).json(); } catch (x) {} pick.disabled = false; pick.classList.remove('is-busy'); }
        host = h0; if (cart.products[h] && cart.products[h].variants) open(cart.products[h]);
        return;
      }
      if (!sheet) return;
      if (e.target.closest('[data-vclose]')) { close(); return; }
      const pill = e.target.closest('.gh-vsheet__pill');
      if (pill) { const di = +pill.dataset.opt; sel[di] = pill.dataset.val; if (!find()) { const v = prod.variants.find(x => vt(x)[di] === pill.dataset.val && x.available) || prod.variants.find(x => vt(x)[di] === pill.dataset.val); if (v) sel = vt(v); } paint(); return; }
      const add = e.target.closest('[data-vadd]');
      if (add && add.dataset.vadd) { add.disabled = true; const fd = new FormData(); fd.append('id', add.dataset.vadd); fd.append('quantity', '1'); try { if (host && host.id === 'gh-added') { const j = await cart.add(fd, { silent: true }); const c = await cart.refresh(); cart.showAdded(j.items ? j.items[0] : j, c); } else await cart.add(fd); close(); } catch (x) { alert(x.message); add.disabled = false; } }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && sheet) { e.stopPropagation(); close(); } }, true);
  })();

  /* ---------- frequently bought together ---------- */
  $$('.gh-fbt').forEach(box => {
    const items = $$('.gh-fbt__item', box), total = $('#gh-fbt-total', box), count = $('#gh-fbt-count', box), btn = $('#gh-fbt-add', box);
    const main = box.querySelector('[data-main]');
    let mainPrice = +(main && main.dataset.price) || 0;
    /* Set-Rabatt: Staffeln „Anzahl|Prozent“ aus der Sektion, nur Anzeige – der Rabatt selbst ist ein automatischer Rabatt in Shopify (Mindestmenge) */
    const tiers = (box.dataset.tiers || '').split(';').map(t => t.split('|')).map(([q, p]) => ({ q: +q, p: +p })).filter(t => t.q > 0 && t.p > 0).sort((a, b) => a.q - b.q);
    const rateFor = n => tiers.reduce((r, t) => n >= t.q ? t.p : r, 0);
    const tiersEl = $('#gh-fbt-tiers', box);
    if (tiersEl) tiersEl.textContent = tiers.length ? tiers.map(t => GHt('{q} Artikel −{p} %', { q: t.q, p: t.p })).join(' · ') + GHt(', wird im Warenkorb automatisch abgezogen') : '';
    const calc = () => {
      let sum = 0, n = 0;
      items.forEach(i => { const c = i.querySelector('input'); if (!c.checked) return; sum += i.hasAttribute('data-main') ? mainPrice : (+i.dataset.price || 0); n++; });
      const rate = rateFor(n), disc = Math.round(sum * rate / 100), top = tiers.length ? tiers[tiers.length - 1] : null;
      total.textContent = fmt(sum - disc); count.textContent = n; btn.disabled = n < 2;
      const save = $('#gh-fbt-save', box);
      const was = $('#gh-fbt-was', box); if (was) { was.hidden = !disc; was.textContent = disc ? fmt(sum) : ''; }
      if (save) { save.hidden = !disc; if (disc) $('#gh-fbt-saved', box).textContent = rate + ' % (' + fmt(disc) + ')'; }
      /* Feedback: Rabatt-Pill, Buttontext und Farbe wechseln mit der Stufe, kurzer Pop bei jeder Änderung */
      const badge = $('#gh-fbt-badge', box), lbl = btn.querySelector('span') || btn, isTop = !!(top && n >= top.q);
      if (badge) { badge.hidden = !rate; badge.textContent = rate ? GHt('−{p} % Set-Rabatt', { p: rate }) : ''; badge.classList.toggle('is-top', isTop); }
      lbl.textContent = n < 2 ? (btn.dataset.label || GHt('In den Warenkorb')) : (n === 2 ? GHt('Beide in den Warenkorb') : GHt('Alle {n} in den Warenkorb', { n })) + (rate ? ' · −' + rate + ' %' : '');
      btn.classList.toggle('is-top', isTop); btn.classList.toggle('is-set', rate > 0);
      if (calc.ready) { [total, badge, btn].forEach(el => { if (!el) return; el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }); }
      calc.ready = true;
    };
    document.addEventListener('gh:variant', e => { const v = e.detail; if (!v || v.price == null) return; mainPrice = v.price; const mp = $('#gh-fbt-main-price', box); if (mp) mp.textContent = fmt(v.price); calc(); });
    items.forEach(i => i.querySelector('input').addEventListener('change', calc));
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      const form = $('#gh-form'), idIn = form && form.querySelector('[name="id"]');
      const ids = []; if (idIn && idIn.value) ids.push(idIn.value);
      items.forEach(i => { const c = i.querySelector('input'); if (i.dataset.variant && c.checked && !c.disabled) ids.push(i.dataset.variant); });
      try { for (const id of ids) { const fd = new FormData(); fd.append('id', id); fd.append('quantity', '1'); await cart.add(fd, { silent: true }); } await cart.refresh(); cart.open(); }
      catch (e) { alert(e.message); }
      btn.disabled = false;
    });
    calc();
  });

  /* ---------- compare cards: mobile competitor switch ---------- */
  $$('.gh-cmp').forEach(cmp => {
    const tabs = $$('.gh-cmp__tabs button', cmp), cards = $$('[data-col]:not(.gh-cmp__card--hi):not(.gh-cmp__mcol--hi):not(.gh-cmp__mv--hi)', cmp);
    const activate = col => { cards.forEach(c => c.classList.toggle('is-active', c.dataset.col === String(col))); tabs.forEach(t => t.classList.toggle('is-on', t.dataset.col === String(col))); };
    if (cards.length) activate(cards[0].dataset.col);
    tabs.forEach(t => t.addEventListener('click', () => activate(t.dataset.col)));
  });

  /* ---------- reviews (own) ---------- */
  const revList = $('#gh-rev-list');
  if (revList) {
    let cards = $$('.gh-rcard', revList), PAGE = 6;
    let filter = 'all', shown = PAGE;
    const more = $('#gh-rev-more');
    // Liquid liefert höchstens 50 Einträge; der Rest kommt vom Backend (/api/reviews/list).
    const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const ago = d => { const days = Math.floor((Date.now() - new Date(d).getTime()) / 864e5); if (!(days >= 0)) return ''; if (days < 1) return GHt('heute'); if (days < 2) return GHt('gestern'); if (days < 7) return GHt('vor {n} Tagen', { n: days }); if (days < 14) return GHt('vor einer Woche'); if (days < 30) return GHt('vor {n} Wochen', { n: Math.floor(days / 7) }); if (days < 60) return GHt('vor einem Monat'); if (days < 395) return GHt('vor {n} Monaten', { n: Math.floor(days / 30) }); return GHt('älter als ein Jahr'); };
    const fmtDate = d => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || ''); return m ? (GHloc === 'de-DE' ? m[3] + '.' + m[2] + '.' + m[1] : m[3] + '/' + m[2] + '/' + m[1]) : ''; };
    const cardHtml = (r, i) => {
      const rv = Math.round(r.rating) || 0, tags = ['s' + rv, r.photos.length ? 'pic' : '', rv < 4 ? 'crit' : '', r.source === 'shop' ? 'shop' : 'marketplace'].filter(Boolean).join(' ');
      let stars = ''; for (let k = 1; k <= 5; k++) stars += '<svg class="gh-ico' + (k > rv ? ' is-off' : '') + '"><use href="#gh-i-star"/></svg>';
      return '<article class="gh-rcard" data-tags="' + tags + '" data-i="' + i + '" hidden><div class="gh-rcard__top"><span class="gh-stars" aria-label="' + GHt('{r} von 5 Sternen', { r: rv }) + '">' + stars + '</span><span class="gh-rcard__meta">' +
        (r.verified ? '<span class="gh-vbadge">' + GHt('Verifizierter Kauf') + '</span>' : '') + '<span>' + esc(r.author) + (r.device ? ' · ' + esc(r.device) : '') + (r.date ? ' · <time datetime="' + esc(r.date) + '" title="' + fmtDate(r.date) + '">' + ago(r.date) + '</time>' : '') + '</span></span></div>' +
        (r.title ? '<b class="gh-rcard__title">' + esc(r.title) + '</b>' : '') + (r.body ? '<p>' + esc(r.body).replace(/\n/g, '<br>') + '</p>' : '') +
        (r.photos.length ? '<div class="gh-rcard__pics">' + r.photos.map(p => '<a href="' + esc(p) + '" target="_blank" rel="noopener"><img src="' + esc(p) + '" alt="' + GHt('Kundenfoto') + '" loading="lazy"></a>').join('') + '</div>' : '') +
        (r.reply ? '<div class="gh-rcard__reply"><b>' + GHt('Antwort von GreenHec:') + '</b> ' + esc(r.reply) + '</div>' : '') + '</article>';
    };
    let allLoaded = null;
    const loadAll = () => {
      if (allLoaded) return allLoaded;
      const total = +revList.dataset.total || 0, api = revList.dataset.api, pid = revList.dataset.product;
      if (!api || !pid || total <= cards.length) return (allLoaded = Promise.resolve(false));
      revList.classList.add('is-loading');
      allLoaded = fetch(api + '?product=' + encodeURIComponent(pid)).then(r => r.json()).then(j => {
        if (!j || !j.ok || !Array.isArray(j.reviews) || j.reviews.length <= cards.length) return false;
        const isDe = (document.documentElement.lang || 'de').slice(0, 2) === 'de';
        const base = isDe ? 0 : cards.length;
        /* Fremdsprache: die per Liquid gelieferten Karten sind übersetzt, vom Backend kommt nur der Rest (deutsch) dazu */
        if (isDe) revList.innerHTML = j.reviews.map(cardHtml).join('');
        else revList.insertAdjacentHTML('beforeend', j.reviews.slice(base).map((r, k) => cardHtml(r, base + k)).join(''));
        cards = $$('.gh-rcard', revList);
        const strip = $('#gh-rev-photos');
        if (strip) {
          const photoBtns = (r, i) => r.photos.map(p => '<button type="button" data-rev="' + i + '" aria-label="' + GHt('Zur Bewertung mit diesem Foto') + '"><img src="' + esc(p) + '" alt="' + GHt('Kundenfoto') + '" loading="lazy"></button>').join('');
          const html = j.reviews.slice(base).map((r, k) => photoBtns(r, base + k)).join('');
          if (isDe) strip.innerHTML = html; else strip.insertAdjacentHTML('beforeend', html);
          bindStrip();
        }
        return true;
      }).catch(() => false).finally(() => revList.classList.remove('is-loading'));
      return allLoaded;
    };
    function apply() {
      const match = cards.filter(c => filter === 'all' || c.dataset.tags.split(' ').includes(filter));
      cards.forEach(c => c.hidden = true);
      match.slice(0, shown).forEach(c => c.hidden = false);
      if (more) { more.hidden = match.length <= shown; more.textContent = GHt('Mehr Bewertungen laden ({n})', { n: Math.max(0, match.length - shown) }); }
      $$('#gh-rev-filters button').forEach(b => b.classList.toggle('is-on', b.dataset.f === filter));
      const none = $('#gh-rev-none'); if (none) none.hidden = match.length > 0;
    }
    $('#gh-rev-filters') && $('#gh-rev-filters').addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; filter = b.dataset.f; shown = PAGE; apply(); loadAll().then(l => l && apply()); });
    $$('#gh-hist button').forEach(b => b.addEventListener('click', () => { filter = b.dataset.f; shown = PAGE; apply(); loadAll().then(l => l && apply()); $('#gh-rev-list').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }));
    more && more.addEventListener('click', () => { shown += PAGE; apply(); loadAll().then(l => l && apply()); });
    // Vorab laden, sobald die Bewertungen ins Bild kommen
    if ('IntersectionObserver' in window) { const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); loadAll().then(l => l && apply()); } }, { rootMargin: '600px' }); io.observe(revList); }
    const reveal = card => {
      filter = 'all'; const k = cards.indexOf(card); shown = Math.max(shown, Math.ceil((k + 1) / PAGE) * PAGE); apply();
      card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      card.classList.remove('is-flash'); void card.offsetWidth; card.classList.add('is-flash'); setTimeout(() => card.classList.remove('is-flash'), 1800);
    };
    function bindStrip() { $$('#gh-rev-photos [data-rev]').forEach(b => b.addEventListener('click', () => {
      const card = revList.querySelector('.gh-rcard[data-i="' + b.dataset.rev + '"]'); if (!card) return;
      const img = b.querySelector('img'), meta = Array.from(card.querySelectorAll('.gh-rcard__meta > span')).pop(), stars = card.querySelector('.gh-stars');
      const lb = document.createElement('div'); lb.className = 'gh gh-lightbox gh-lightbox--rev';
      lb.innerHTML = `<figure><img src="${img.src}" alt="${GHt('Kundenfoto')}"><figcaption>${stars ? stars.outerHTML : ''}<span>${esc(meta ? meta.textContent.trim() : '')}</span><button type="button" class="gh-btn gh-btn--cta" data-goto>${GHt('Zur Bewertung')}</button></figcaption></figure><button type="button" class="gh-lightbox__x" aria-label="${GHt('Schließen')}"><svg class="gh-ico" style="width:32px;height:32px"><use href="#gh-i-x"/></svg></button>`;
      const close = () => { lb.remove(); document.removeEventListener('keydown', onKey); };
      function onKey(ev) { if (ev.key === 'Escape') close(); }
      lb.addEventListener('click', e => { if (e.target.closest('[data-goto]')) { close(); reveal(card); return; } if (!e.target.closest('figure') || e.target.tagName === 'IMG') close(); });
      document.addEventListener('keydown', onKey);
      document.body.appendChild(lb);
    })); }
    bindStrip();
    apply();
    /* Übersetzte Bewertungen: Knopf „Original anzeigen“. Das Original holt sich die Seite einmalig aus der deutschen Fassung derselben Seite (gleiche Reihenfolge, data-i). */
    const lang2 = (document.documentElement.lang || 'de').slice(0, 2);
    if (lang2 !== 'de') {
      const T = { note: revList.dataset.tNote || '', orig: revList.dataset.tOrig || '', trans: revList.dataset.tTrans || '' };
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const dePath = root !== '/' && location.pathname.indexOf(root) === 0 ? '/' + location.pathname.slice(root.length) : location.pathname.replace(/^\/[a-z]{2}(?=\/)/, '');
      let origMap = null;
      const norm = s => String(s || '').replace(/\s+/g, ' ').trim();
      const txt = el => { if (!el) return ''; const k = el.cloneNode(true); k.querySelectorAll('br').forEach(x => x.replaceWith(String.fromCharCode(10))); return k.textContent; };
      const pick = c => ({ title: txt(c.querySelector('.gh-rcard__title')), body: txt(c.querySelector(':scope > p')), reply: txt(c.querySelector('.gh-rcard__reply')), author: (() => { const sp = c.querySelector('.gh-rcard__meta > span:last-child'); return sp && sp.firstChild ? sp.firstChild.textContent : ''; })() });
      const getOrig = () => origMap || (origMap = fetch(dePath, { credentials: 'same-origin' }).then(r => r.ok ? r.text() : Promise.reject()).then(h => {
        const doc = new DOMParser().parseFromString(h, 'text/html'), m = {};
        doc.querySelectorAll('#gh-rev-list .gh-rcard').forEach(c => { m[c.dataset.i] = { title: pick(c).title, body: pick(c).body, reply: pick(c).reply, author: pick(c).author, hasReply: !!c.querySelector('.gh-rcard__reply') }; });
        return m;
      }).catch(() => ({})));
      const setText = (el, v) => { if (el) el.textContent = v; };
      const show = (card, o, toOrig) => {
        const set = toOrig ? o.o : o.t;
        setText(card.querySelector('.gh-rcard__title'), set.title);
        const p = card.querySelector(':scope > p'); if (p) p.textContent = set.body;
        const rp = card.querySelector('.gh-rcard__reply'); if (rp && set.reply) { const b = rp.querySelector('b'); const label = b ? b.outerHTML + ' ' : ''; const txt = norm(set.reply); const lab = b ? norm(b.textContent) : ''; rp.innerHTML = label + (lab && txt.indexOf(lab) === 0 ? txt.slice(lab.length).trim() : txt).replace(/[&<>]/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[ch])); }
        const sp = card.querySelector('.gh-rcard__meta > span:last-child'); if (sp && sp.firstChild && set.author) sp.firstChild.textContent = set.author;
      };
      const decorate = () => getOrig().then(m => {
        cards.forEach(card => {
          if (card.querySelector('.gh-rcard__tr') || !m[card.dataset.i]) return;
          const t = pick(card), o = m[card.dataset.i];
          const cut = (txt, lab) => { txt = norm(txt); return lab && txt.indexOf(lab) === 0 ? txt.slice(lab.length).trim() : txt; };
          const rpl = card.querySelector('.gh-rcard__reply'), rlab = rpl && rpl.querySelector('b') ? norm(rpl.querySelector('b').textContent) : '';
          const tNow = { title: norm(t.title), body: norm(t.body), reply: cut(t.reply, rlab), author: norm(t.author) };
          const olab = (() => { const x = (new DOMParser()).parseFromString('<div></div>', 'text/html'); return ''; })();
          void olab;
          const oNow = { title: norm(o.title), body: norm(o.body), reply: o.hasReply ? norm(o.reply).replace(/^[^:]*:\s*/, '') : '', author: norm(o.author) };
          const changed = tNow.title !== oNow.title || tNow.body !== oNow.body || (tNow.reply !== oNow.reply) || tNow.author !== oNow.author;
          if (!changed) return;
          const state = { t: { title: t.title, body: t.body, reply: tNow.reply, author: t.author }, o: { title: o.title, body: o.body, reply: oNow.reply, author: o.author }, orig: false };
          const btn = document.createElement('button'); btn.type = 'button'; btn.className = 'gh-rcard__tr';
          const label = () => { btn.textContent = state.orig ? T.trans : T.note + ' · ' + T.orig; };
          label();
          btn.addEventListener('click', () => { state.orig = !state.orig; show(card, state, state.orig); label(); });
          card.appendChild(btn);
        });
      });
      window.GHrevTr = decorate;
      if ('IntersectionObserver' in window) { const io2 = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io2.disconnect(); decorate(); } }, { rootMargin: '400px' }); io2.observe(revList); } else decorate();
    }
  }
  /* write-review form: also on products without reviews yet */
  const wbtn = $('#gh-write-review'), wform = $('#gh-rev-form');
  wbtn && wform && wbtn.addEventListener('click', () => { wform.hidden = !wform.hidden; if (!wform.hidden) wform.querySelector('input[name=name]').focus(); });
  wform && wform.addEventListener('submit', async e => {
    e.preventDefault();
    const err = $('#gh-rev-error'), btn = wform.querySelector('button[type=submit]');
    const files = wform.querySelector('input[type=file]');
    if (files && files.files.length > 3) { err.textContent = GHt('Bitte höchstens 3 Fotos.'); err.hidden = false; return; }
    if (!wform.reportValidity()) return;
    err.hidden = true; btn.disabled = true; const label = btn.textContent; btn.textContent = GHt('Wird gesendet …');
    try {
      const r = await fetch(wform.action, { method: 'POST', body: new FormData(wform) });
      const j = await r.json().catch(() => ({}));
      if (r.ok && j.ok) { wform.hidden = true; wform.reset(); const ok = $('#gh-rev-ok'); ok.hidden = false; ok.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
      else { err.textContent = j.error || GHt('Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal.'); err.hidden = false; }
    } catch (x) { err.textContent = GHt('Keine Verbindung. Bitte versuch es gleich noch einmal.'); err.hidden = false; }
    btn.disabled = false; btn.textContent = label;
  });
  $$('.gh-starpick input').forEach(i => i.addEventListener('change', () => { const v = +i.value; $$('.gh-starpick label').forEach((l, k) => l.classList.toggle('is-on', k < v)); }));

  /* ---------- product page ---------- */
  const dataEl = $('#gh-product-json');
  if (!dataEl) return;
  let D = null; try { D = JSON.parse(dataEl.textContent); } catch (e) { console.error('gh-product-json', e); }
  if (!D) return;
  window.GH = Object.assign(window.GH || {}, { moneyFormat: D.moneyFormat });
  const P = D.product, S = D.settings;
  const root = $('#gh-product');
  const form = $('#gh-form', root);
  const idInput = form && form.querySelector('[name="id"]');
  const qtyInput = form && form.querySelector('[name="quantity"]');

  /* --- dimensions (real options or split single option) --- */
  /* Marktplatz-/Bundle-Varianten (Varianten-Metafeld custom.shop_ausblenden) bleiben im Datensatz (P.all), fliegen aber aus dem Picker. */
  P.all = P.variants.slice();
  const shopVariants = P.variants.filter(v => !v.hidden);
  if (shopVariants.length) P.variants = shopVariants;
  /* --- Darstellung je Optionsebene: Stiltabelle aus den Sektionseinstellungen, Übersteuerung per Produkt-Metafeld custom.shop_optionsstile --- */
  /* Optionsnamen kommen in anderen Sprachen übersetzt an (Farbe → Color): auf den deutschen Schlüssel zurückführen, damit Stiltabelle und Overrides greifen */
  const OPT_ALIAS = { color: 'farbe', colour: 'farbe', couleur: 'farbe', model: 'modell', modelo: 'modell', 'modèle': 'modell', device: 'modell', 'display size': 'displaygröße', 'screen size': 'displaygröße', capacity: 'kapazität', battery: 'akku', 'function': 'funktion', length: 'länge', quantity: 'anzahl', number: 'anzahl', selection: 'auswahl', choice: 'auswahl', option: 'auswahl', variant: 'variante', size: 'größe', "sélection": "auswahl", "longueur": "länge", "quantité": "anzahl", "modèle d’iphone": "iphone modell", "modèle d’iphone :": "iphone modell:", "batterie": "akku", "taille d’écran": "displaygröße", "fonction": "funktion", "taille": "größe", "selección": "auswahl", "longitud": "länge", "cantidad": "anzahl", "modelo de iphone": "iphone modell", "batería": "akku", "tamaño de pantalla": "displaygröße", "función": "funktion", "tamaño": "größe", "versión": "ausführung", "keuze": "auswahl", "kleur": "farbe", "lengte": "länge", "uitvoering": "ausführung", "aantal": "anzahl", "iphone-model": "iphone modell", "iphone-model:": "iphone modell:", "accu": "akku", "schermgrootte": "displaygröße", "functie": "funktion", "variant": "variante", "maat": "größe", "selezione": "auswahl", "modello": "modell", "colore": "farbe", "lunghezza": "länge", "versione": "ausführung", "quantità": "anzahl", "modello iphone": "iphone modell", "modello iphone:": "iphone modell:", "batteria": "akku", "dimensione schermo": "displaygröße", "funzione": "funktion", "dimensione": "größe", "wybór": "auswahl", "kolor": "farbe", "długość": "länge", "wersja": "ausführung", "ilość": "anzahl", "model iphone": "iphone modell", "model iphone:": "iphone modell:", "akumulator": "akku", "rozmiar ekranu": "displaygröße", "funkcja": "funktion", "wariant": "variante", "rozmiar": "größe", "valg": "auswahl", "farve": "farbe", "længde": "länge", "udførelse": "ausführung", "antal": "anzahl", "batteri": "akku", "skærmstørrelse": "displaygröße", "størrelse": "größe", "iphone model": "iphone modell", "iphone model:": "iphone modell:", "val": "auswahl", "färg": "farbe", "längd": "länge", "utförande": "ausführung", "iphone-modell": "iphone modell", "iphone-modell:": "iphone modell:", "skärmstorlek": "displaygröße", "storlek": "größe", "seçim": "auswahl", "renk": "farbe", "uzunluk": "länge", "versiyon": "ausführung", "kablo": "kabel", "adet": "anzahl", "iphone modeli": "iphone modell", "iphone modeli:": "iphone modell:", "batarya": "akku", "ekran boyutu": "displaygröße", "özellik": "funktion", "varyant": "variante", "boyut": "größe", speed: "geschwindigkeit", "vitesse": "geschwindigkeit", "velocidad": "geschwindigkeit", "snelheid": "geschwindigkeit", "velocità": "geschwindigkeit", "prędkość": "geschwindigkeit", "hastighed": "geschwindigkeit", "hastighet": "geschwindigkeit", "hız": "geschwindigkeit" };
  /* Aliasse der Sprache aus dem Wörterbuch (content/i18n/js-<sprache>.json, Schlüssel __optAlias: übersetzter Name kleingeschrieben → deutscher Schlüssel) */
  try { Object.assign(OPT_ALIAS, (window.GHi18n && window.GHi18n.__optAlias) || {}); } catch (e) { /* kein Wörterbuch */ }
  const optKey = name => { const k = String(name || '').toLowerCase().trim(); return OPT_ALIAS[k] || k; };
  const styleMap = {}; Object.keys(S.styles || {}).forEach(k => { styleMap[k.toLowerCase()] = S.styles[k]; });
  let splitNames = null, splitKeys = null;
  String(S.overrides || '').split(/\r?\n/).forEach(line => {
    const parts = line.split('|').map(s => s.trim()); if (!parts[0]) return;
    if (parts[0].toLowerCase() === 'split') { splitNames = [GHt(parts[1] || 'Option 1'), GHt(parts[2] || 'Option 2')]; splitKeys = [optKey(parts[1] || ''), optKey(parts[2] || '')]; return; }
    if (parts[1]) styleMap[optKey(parts[0])] = parts[1].toLowerCase();
  });
  const split = !!splitNames && P.options.length === 1;
  const variantTokens = v => split ? (() => { const [a, ...b] = v.options[0].split(' '); return [a, b.join(' ')]; })() : v.options.slice();
  let dims = [];
  if (split) {
    const firsts = [], rests = [];
    P.variants.forEach(v => { const [a, ...b] = v.options[0].split(' '); const r = b.join(' '); if (!firsts.includes(a)) firsts.push(a); if (!rests.includes(r)) rests.push(r); });
    dims = [{ name: splitNames[0], key: splitKeys[0], values: firsts }, { name: splitNames[1], key: splitKeys[1], values: rests }];
  } else {
    dims = P.options.map((o, di) => ({ name: o.name, key: optKey(o.name), values: o.values.filter(val => P.variants.some(v => variantTokens(v)[di] === val)) }));
  }
  const colorFor = val => { const k = val.toLowerCase().replace(/gray/g, 'grey'); const m = S.colors || {}; for (const key in m) if (k.includes(key)) return m[key]; return null; };
  /* Regeln: swatches nur, wenn alle Werte eine bekannte Farbe haben · device: ab S.ddDevice Werten Dropdown mit Suche, sonst Chips · cards: bis 3 Werte Karten, sonst Chips · auto/unbekannt: bis 3 Karten, dann Chips, ab S.ddAuto Dropdown · ein Wert: ausgeblendet */
  function resolveStyle(d) {
    const n = d.values.length, want = styleMap[d.key] || styleMap[d.name.toLowerCase()] || 'auto';
    if (n <= 1 || want === 'hidden') return 'hidden';
    if (want === 'swatches') return d.values.every(v => colorFor(v)) ? 'swatches' : 'chips';
    if (want === 'device') return n >= (S.ddDevice || 25) ? 'dropdown' : 'chips';
    if (want === 'dropdown' || want === 'chips') return want;
    if (want === 'cards') return n <= 3 ? 'cards' : 'chips';
    return n <= 3 ? 'cards' : (n >= (S.ddAuto || 10) ? 'dropdown' : 'chips');
  }
  dims.forEach(d => { d.style = resolveStyle(d); d.single = d.style === 'hidden'; });

  /* Startzustand: ohne ?variant= in der URL ist nichts gewählt (verhindert Fehlkäufe). Ausnahmen: Optionen mit nur einem Wert und das in der Kompatibilitäts-Sektion gemerkte Gerät (gh-device). */
  const fallback = P.variants.find(v => v.id === P.selectedId) || P.variants.find(v => v.available) || P.variants[0];
  const matches = s => P.variants.filter(v => variantTokens(v).every((t, i) => s[i] == null || t === s[i]));
  const findVariant = s => s.every(x => x != null) ? P.variants.find(v => variantTokens(v).every((t, i) => t === s[i])) : undefined;
  const urlVariant = new URLSearchParams(location.search).has('variant') ? P.variants.find(v => v.id === P.selectedId) : null;
  let sel = urlVariant ? variantTokens(urlVariant) : dims.map(d => d.single ? d.values[0] : null);
  if (!urlVariant) {
    let dev = null; try { dev = (localStorage.getItem('gh-device') || '').split('|')[1] || null; } catch (e) {}
    const ddi = dims.findIndex(d => /modell|model|ger[äa]t|device/i.test(d.name));
    if (dev && ddi >= 0 && sel[ddi] == null) {
      const key = dev.toLowerCase(), vals = dims[ddi].values;
      const val = vals.find(v => v.toLowerCase() === key) || vals.find(v => v.toLowerCase().endsWith(key)) || vals.find(v => v.toLowerCase().includes(key));
      if (val) sel[ddi] = val;
    }
  }
  /* Alle sichtbaren Ebenen gesetzt, aber keine Variante dazu (z. B. ausgeblendete Ebene mit mehreren Werten): nächstpassende Variante nehmen */
  if (!findVariant(sel) && dims.every((d, i) => d.single || sel[i] != null)) sel = variantTokens(matches(sel)[0] || fallback);
  let qty = 1;
  const missingDims = () => dims.map((d, i) => sel[i] == null && !d.single ? i : -1).filter(i => i >= 0);
  const valueAvailable = (di, val) => P.variants.some(v => v.available && variantTokens(v).every((t, i) => i === di ? t === val : (sel[i] == null || t === sel[i])));
  const valuePrice = (di, val) => { const c = P.variants.filter(v => variantTokens(v).every((t, i) => i === di ? t === val : (sel[i] == null || t === sel[i]))); return c.length ? Math.min(...c.map(v => v.price)) : null; };
  const pretty = val => val.replace(/^(\d{4,6})\s*mah$/i, (m, n) => Number(n).toLocaleString(GHloc) + ' mAh').replace(/^(\d+)\s*w$/i, '$1 W');
  /* Schlüssel tolerant vergleichen: Groß-/Kleinschreibung, Leerzeichen und Bindestriche spielen keine Rolle (übersetzte Optionswerte wie „1-pack“) */
  const hintNorm = x => String(x).toLowerCase().replace(/[\s_-]+/g, '');
  const hintIdx = {}; Object.keys(S.hints || {}).forEach(k => { hintIdx[hintNorm(k)] = S.hints[k]; });
  const hintFor = val => (S.hints || {})[val] || (S.hints || {})[val.toLowerCase()] || hintIdx[hintNorm(val)] || {};
  /* Flamme „Beliebt“: Tag „hot“/„🔥“ (optional mit eigenem Text) in den Werte-Hinweisen, sonst automatisch der teuerste Wert einer Set-/Auswahl-Option (S.hotAuto) */
  const isBundleDim = d => /auswahl|variante|set|paket|bundle|version|ausstattung|funktion|umfang|anzahl|pack|selection|choice|variant|option|equipment|function|scope|quantity/i.test(d.name + ' ' + (d.key || ''));
  const hotFor = (di, v) => {
    const h = hintFor(v);
    if (h.tag && /hot|🔥/i.test(h.tag)) return h.tag.replace(/hot|🔥/ig, '').trim() || GHt('Beliebt');
    if (!S.hotAuto || !isBundleDim(dims[di]) || dims[di].values.length < 2) return null;
    const prices = dims[di].values.map(x => valuePrice(di, x)).filter(p => p != null); if (!prices.length) return null;
    const max = Math.max(...prices); return valuePrice(di, v) === max && prices.filter(p => p === max).length === 1 ? GHt('Beliebt') : null;
  };
  /* Kurzform für die Anzeige: gemeinsamen Wortanfang aller Werte einer Option entfernen („55w Quatro Charger + 1m Kabel“ → „+ 1m Kabel“, „… (Ladegerät)“ → „Ladegerät“) */
  const shortMap = dims.map(d => {
    const parts = d.values.map(v => v.split(/\s+/)); if (parts.length < 2) return null;
    let n = 0; while (parts.every(p => p.length > n + 1 && p[n] === parts[0][n])) n++;
    while (n > 0 && /^[+&\-–]$/.test(parts[0][n - 1])) n--;
    if (n < 2) return null; const m = {};
    d.values.forEach((v, i) => { let s = parts[i].slice(n).join(' ').trim(); s = s.replace(/^\(([^()]*)\)$/, '$1'); m[v] = s || v; });
    return m;
  });
  const disp = (di, v) => pretty((shortMap[di] && shortMap[di][v]) || v);
  const hotMark = (di, v, cls) => { const t = hotFor(di, v); return t ? `<span class="gh-tag gh-tag--hot ${cls || ''}"><svg class="gh-ico"><use href="#gh-i-flame"/></svg>${esc(t)}</span>` : ''; };
  const attr = s => String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  /* Gruppe für die Gerätewahl: „iPhone 16e“ → „iPhone 16“, „Galaxy S25 Ultra“ → „Galaxy S25“, „Galaxy Z Fold 8“ → „Galaxy Z“, „Pixel 9a“ → „Pixel 9“ */
  const groupOf = val => { const t = val.replace(/^(samsung|google|apple)\s+/i, '').split(/\s+/); if (t.length < 2) return t[0]; let g = t[1].replace(/[^\p{L}\p{N}]+$/u, ''); if (/\d/.test(g)) g = g.replace(/[a-z]+$/i, ''); return t[0] + ' ' + g; };

  const optsWrap = $('#gh-options');
  function renderOptions() {
    if (!optsWrap) return;
    optsWrap.innerHTML = dims.map((d, di) => {
      if (d.single) return '';
      const cur = sel[di];
      const label = `<div class="gh-opt__label">${esc(d.name)} <span data-optlabel="${di}">${esc(cur == null ? '' : (d.style === 'swatches' ? cur : (hintFor(cur).label || '')))}</span></div>`;
      const btn = (cls, v, inner, extra) => `<button type="button" class="${cls} ${v === cur ? 'is-on' : ''} ${valueAvailable(di, v) ? '' : 'is-out'}" data-dim="${di}" data-val="${attr(v)}"${extra || ''}>${inner}</button>`;
      let body = '';
      if (d.style === 'swatches') {
        body = '<div class="gh-swatches">' + d.values.map(v => btn('gh-swatch', v, `<i style="background:${colorFor(v) || '#D9DEE2'}"></i>`, ` aria-label="${attr(v)}" title="${attr(v)}"`)).join('') + '</div>';
      } else if (d.style === 'chips') {
        body = '<div class="gh-swatches">' + d.values.map(v => btn('gh-pill', v, esc(disp(di, v)) + hotMark(di, v, 'gh-tag--inl'))).join('') + '</div>';
      } else if (d.style === 'dropdown') {
        const groups = []; d.values.forEach(v => { const g = groupOf(v); let e = groups.find(x => x.g === g); if (!e) { e = { g, items: [] }; groups.push(e); } e.items.push(v); });
        const useGroups = groups.length > 1 && groups.length < d.values.length;
        const item = v => btn('gh-dd__item', v, `<span>${esc(disp(di, v))}${hotMark(di, v, 'gh-tag--inl')}</span>${valueAvailable(di, v) ? '' : '<small>' + GHt('ausverkauft') + '</small>'}`, ' role="option"');
        const list = useGroups ? groups.map(x => `<div class="gh-dd__group" data-group>${esc(x.g)}</div>` + x.items.map(item).join('')).join('') : d.values.map(item).join('');
        body = `<div class="gh-dd"><button type="button" class="gh-dd__btn ${cur == null ? 'is-empty' : ''}" data-ddbtn aria-haspopup="listbox" aria-expanded="false"><span>${cur == null ? GHt('{name} wählen', { name: esc(d.name) }) : esc(disp(di, cur))}</span><svg class="gh-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></button><div class="gh-dd__panel" hidden><div class="gh-dd__search"><input type="search" autocomplete="off" placeholder="${GHt('{name} suchen …', { name: attr(d.name) })}" aria-label="${GHt('{name} suchen', { name: attr(d.name) })}"></div><div class="gh-dd__list" role="listbox">${list}<div class="gh-dd__empty" hidden>${GHt('Kein Treffer')}</div></div></div></div>`;
      } else {
        body = `<div class="gh-cards ${d.values.length === 3 ? 'gh-cards--3' : ''}">` + d.values.map(v => { const h = hintFor(v), p = valuePrice(di, v); return btn('gh-card-opt', v, (hotMark(di, v) || (h.tag ? `<span class="gh-tag">${esc(h.tag)}</span>` : '')) + `<strong>${esc(disp(di, v))}</strong>` + (h.sub ? `<small>${esc(h.sub)}</small>` : '') + (p != null ? `<span class="gh-p gh-num">${fmt(p)}</span>` : '')); }).join('') + '</div>';
      }
      return `<div class="gh-opt" data-di="${di}">${label}${body}</div>`;
    }).join('');
  }
  /* Dropdown öffnen/schließen und filtern */
  function closeDd() { $$('.gh-dd__btn[aria-expanded="true"]', optsWrap).forEach(b => { b.setAttribute('aria-expanded', 'false'); b.nextElementSibling.hidden = true; }); }
  optsWrap && optsWrap.addEventListener('click', e => {
    const ddb = e.target.closest('[data-ddbtn]');
    if (ddb) { const open = ddb.getAttribute('aria-expanded') === 'true'; closeDd(); if (!open) { ddb.setAttribute('aria-expanded', 'true'); const p = ddb.nextElementSibling; p.hidden = false; const on = p.querySelector('.is-on'); if (on) on.scrollIntoView({ block: 'center' }); if (window.matchMedia('(min-width: 768px)').matches) p.querySelector('input').focus(); } return; }
    const b = e.target.closest('[data-dim]'); if (!b) return;
    sel[+b.dataset.dim] = b.dataset.val;
    if (sel.every(x => x != null) && !findVariant(sel)) {
      /* Kombination gibt es nicht: andere Ebenen auf eine passende Variante umstellen */
      const v = P.variants.find(x => variantTokens(x)[+b.dataset.dim] === b.dataset.val && x.available) || P.variants.find(x => variantTokens(x)[+b.dataset.dim] === b.dataset.val);
      if (v) sel = variantTokens(v);
    }
    renderOptions(); update(true);
  });
  optsWrap && optsWrap.addEventListener('input', e => {
    const inp = e.target.closest('.gh-dd__search input'); if (!inp) return;
    const q = inp.value.trim().toLowerCase(), list = inp.closest('.gh-dd__panel').querySelector('.gh-dd__list');
    let hits = 0; $$('.gh-dd__item', list).forEach(it => { const ok = !q || it.dataset.val.toLowerCase().includes(q); it.hidden = !ok; if (ok) hits++; });
    $$('[data-group]', list).forEach(g => { let n = g.nextElementSibling, any = false; while (n && !n.hasAttribute('data-group') && !n.classList.contains('gh-dd__empty')) { if (!n.hidden) any = true; n = n.nextElementSibling; } g.hidden = !any; });
    list.querySelector('.gh-dd__empty').hidden = hits > 0;
  });
  document.addEventListener('click', e => { if (optsWrap && !e.target.closest('.gh-dd')) closeDd(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDd(); });
  /* Kauf ohne vollständige Auswahl: zur ersten offenen Option scrollen, rot markieren, Hinweis zeigen, Dropdown öffnen */
  function needSelection() {
    const di = missingDims()[0]; if (di == null || !optsWrap) return;
    const box = optsWrap.querySelector(`.gh-opt[data-di="${di}"]`); if (!box) return;
    const d = dims[di], txt = /modell|model/i.test(d.name) ? GHt('Bitte wähle zuerst dein Modell') : (/farbe|colou?r/i.test(d.name + ' ' + (d.key || '')) ? GHt('Bitte wähle zuerst eine Farbe') : GHt('Bitte wähle zuerst: {name}', { name: d.name }));
    $$('.gh-opt.is-need', optsWrap).forEach(o => { o.classList.remove('is-need'); const n = o.querySelector('.gh-opt__need'); if (n) n.remove(); });
    box.classList.add('is-need'); const n = document.createElement('div'); n.className = 'gh-opt__need'; n.setAttribute('role', 'alert'); n.textContent = txt; box.appendChild(n);
    box.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    const ddb = box.querySelector('[data-ddbtn]'); if (ddb && ddb.getAttribute('aria-expanded') !== 'true') setTimeout(() => ddb.click(), reduce ? 0 : 350);
  }

  /* PayPal-Button bleibt ohne Auswahl sichtbar; Klick darauf fordert erst die Auswahl an */
  const expressWrap = $('.gh-express > div:first-child');
  expressWrap && expressWrap.addEventListener('click', e => { const f = expressWrap.closest('.gh-form'); if (f && f.classList.contains('is-incomplete')) { e.preventDefault(); e.stopPropagation(); needSelection(); } }, true);

  /* --- packs --- */
  const packsWrap = $('#gh-packs');
  function renderPacks(unit) {
    if (!packsWrap) return;
    packsWrap.innerHTML = (S.packs || []).map(p => { const total = unit * p.qty - p.off; return `<button type="button" class="gh-pack ${p.qty === qty ? 'is-on' : ''}" data-qty="${p.qty}">${p.tag ? `<span class="gh-tag">${esc(p.tag)}</span>` : ''}<strong>${GHt('{n} Stück', { n: p.qty })}</strong>${p.off ? `<span class="gh-save gh-num">${GHt('Spare {a}', { a: fmt(p.off) })}</span>` : ''}<span class="gh-each gh-num">${GHt('{a} / Stück', { a: fmt(Math.round(total / p.qty)) })}</span></button>`; }).join('');
  }
  packsWrap && packsWrap.addEventListener('click', e => {
    const b = e.target.closest('.gh-pack'); if (!b) return;
    qty = +b.dataset.qty; update(false);
    const p = (S.packs || []).find(x => x.qty === qty);
    if (p && p.code) fetch('/discount/' + encodeURIComponent(p.code), { credentials: 'same-origin' }).catch(() => {});
  });

  /* --- delivery --- */
  function delivery(available) {
    const box = $('#gh-deliver'); if (!box) return;
    box.classList.toggle('gh-deliver--out', !available);
    const p = window.GHship.plan({ cutoff: S.cutoffHour, minDays: S.minDays, maxDays: S.maxDays }), f = window.GHship.fmt;
    $('#gh-stock').innerHTML = available ? `<strong>${GHt('Auf Lager')}</strong> · ${esc(S.shipFrom || '')}` : `<strong>${GHt('Zurzeit ausverkauft')}</strong> · ${GHt('wir benachrichtigen dich')}`;
    const si = $('#gh-stock-ico'); if (si) si.classList.toggle('is-off', !available);
    window.__ghDelivAvail = available;
    const a = f(p.earliest), b = f(p.latest);
    $('#gh-deliv-line').textContent = available ? GHt('Lieferung voraussichtlich {d}', { d: a === b ? a : a + ' – ' + b }) : GHt('Lieferzeit nach Verfügbarkeit');
    const co = $('#gh-cutoff');
    if (!available) co.textContent = '';
    else if (p.sameDay) { const h = Math.floor(p.minsLeft / 60), m = p.minsLeft % 60; co.textContent = GHt('Bestell in den nächsten {t} und wir versenden noch heute.', { t: (h ? h + ' ' + GHt('Std.') + ' ' : '') + m + ' ' + GHt('Min.') }); }
    else co.textContent = GHt('Versand am {d}', { d: f(p.ship) }) + (p.gap === 1 ? ' ' + GHt('(morgen)') : '') + ' · ' + GHt('heute kein Versand mehr: {r}.', { r: p.reason });
  }

  /* --- gallery --- */
  const track = $('#gh-track'), thumbs = $('#gh-thumbs'), dots = $('#gh-dots'), count = $('#gh-count');
  const allSlides = track ? $$('.gh-slide', track) : [];
  let slides = allSlides.slice();
  let cur = 0;
  /* Variantenbilder: Bilder, die einer Variante zugewiesen sind, zeigt die Galerie erst nach der Auswahl (das gewählte zuerst). Ohne Auswahl nur Titelbild + freie Hauptbilder. */
  const assignedMedia = new Set((P.all || P.variants).map(v => v.featured_media_id).filter(Boolean));
  /* Das erste Produktbild (Titelbild) bleibt immer in der Galerie, auch wenn es zusätzlich einer Variante zugewiesen ist. */
  const freeSlides = allSlides.filter((s, i) => i === 0 || !assignedMedia.has(+s.dataset.mediaId));
  const galleryFilters = assignedMedia.size > 0 && freeSlides.length > 0;
  function applyGallery(mediaId) {
    if (!track || !galleryFilters) return;
    const pick = mediaId ? allSlides.find(s => +s.dataset.mediaId === mediaId) : null;
    /* Variantenbild ersetzt das Titelbild (erstes Produktbild); ohne Variantenbild bleibt das Titelbild stehen */
    const vis = pick ? [pick, ...freeSlides.filter(s => s !== pick && s !== allSlides[0])] : freeSlides.slice();
    allSlides.forEach(s => { s.hidden = !vis.includes(s); });
    vis.forEach(s => track.appendChild(s));
    slides = vis;
    if (thumbs) $$('.gh-thumb', thumbs).forEach(t => { const i = vis.findIndex(s => s.dataset.mediaId === t.dataset.mediaId); t.hidden = i < 0; if (i >= 0) { t.dataset.i = i; thumbs.appendChild(t); } });
    if (dots) dots.innerHTML = vis.map(() => '<i></i>').join('');
    track.scrollTo({ left: 0 }); setCur(0, false);
  }
  function syncHeight() { if (track && slides[cur]) track.style.height = slides[cur].offsetHeight + 'px'; }
  function setCur(i, scroll = true) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    thumbs && $$('.gh-thumb', thumbs).forEach(t => { const k = +t.dataset.i; t.classList.toggle('is-on', k === cur); if (k === cur) t.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); });
    dots && $$('i', dots).forEach((d, k) => d.classList.toggle('is-on', k === cur));
    if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
    if (scroll) track.scrollTo({ left: cur * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    syncHeight();
    $$('video', track).forEach(v => { if (slides.indexOf(v.closest('.gh-slide')) !== cur) v.pause(); });
  }
  if (track) {
    thumbs && thumbs.addEventListener('click', e => { const b = e.target.closest('.gh-thumb'); if (b) setCur(+b.dataset.i); });
    $('#gh-prev') && $('#gh-prev').addEventListener('click', () => setCur(cur - 1));
    $('#gh-next') && $('#gh-next').addEventListener('click', () => setCur(cur + 1));
    track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') setCur(cur + 1); if (e.key === 'ArrowLeft') setCur(cur - 1); });
    let st; track.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) setCur(i, false); }, 80); });
    window.addEventListener('resize', () => { syncHeight(); track.scrollTo({ left: cur * track.clientWidth }); });
    slides.forEach(s => { const img = s.querySelector('img'); if (img) { img.addEventListener('load', () => { if (slides[cur] === s) syncHeight(); }); if (img.complete) syncHeight(); } });
    /* --- Vollbild: Karte mit wischbarem Bildstreifen, Pfeilen, Zähler, Zoom per Klick --- */
    function openLightbox(startIdx) {
      const pics = slides.map((s, k) => { const im = s.querySelector('img'); return im && !s.classList.contains('gh-slide--video') ? { src: im.dataset.full || im.src, alt: im.alt || '', k } : null; }).filter(Boolean);
      if (!pics.length) return;
      let idx = Math.max(0, pics.findIndex(p => p.k === startIdx));
      const lb = document.createElement('div'); lb.className = 'gh gh-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', GHt('Bildansicht'));
      lb.innerHTML = `<div class="gh-lb__scrim" data-lb-close></div><div class="gh-lb__card">
        <button type="button" class="gh-lb__x" data-lb-close aria-label="${GHt('Schließen')}"><svg class="gh-ico"><use href="#gh-i-x"/></svg></button>
        <div class="gh-lb__track">${pics.map(p => `<div class="gh-lb__slide"><img src="${p.src}" alt="${p.alt.replace(/"/g, '&quot;')}" draggable="false"></div>`).join('')}</div>
        ${pics.length > 1 ? `<button type="button" class="gh-lb__nav gh-lb__nav--prev" data-lb="-1" aria-label="${GHt('Vorheriges Bild')}"><svg class="gh-ico"><use href="#gh-i-left"/></svg></button><button type="button" class="gh-lb__nav gh-lb__nav--next" data-lb="1" aria-label="${GHt('Nächstes Bild')}"><svg class="gh-ico"><use href="#gh-i-right"/></svg></button>` : ''}
        <div class="gh-lb__foot"><span class="gh-lb__count gh-num"></span><div class="gh-lb__dots">${pics.map((p, k) => `<button type="button" data-lb-go="${k}" aria-label="${GHt('Bild {n}', { n: k + 1 })}"></button>`).join('')}</div><span class="gh-lb__hint">${GHt('Klicken zum Zoomen, ziehen zum Bewegen')}</span></div>
      </div>`;
      const tr = $('.gh-lb__track', lb), lbSlides = $$('.gh-lb__slide', lb), cnt = $('.gh-lb__count', lb), dots = $$('.gh-lb__dots button', lb);
      const paint = () => { cnt.textContent = (idx + 1) + ' / ' + pics.length; dots.forEach((d, k) => d.classList.toggle('is-on', k === idx)); };
      const Z = 2.6, dist = (p, q) => Math.hypot(p.x - q.x, p.y - q.y);
      const unzoom = s => { s.classList.remove('is-zoom'); const im = s.querySelector('img'); if (im) { im.style.transform = ''; im.dataset.tx = 0; im.dataset.ty = 0; im.dataset.z = 1; } };
      function setPan(im, tx, ty) {
        const z = +im.dataset.z || 1, s = im.parentElement.getBoundingClientRect();
        const maxX = Math.max(0, (im.offsetWidth * z - s.width) / 2 + 24), maxY = Math.max(0, (im.offsetHeight * z - s.height) / 2 + 24);
        tx = Math.max(-maxX, Math.min(maxX, tx)); ty = Math.max(-maxY, Math.min(maxY, ty));
        im.dataset.tx = tx; im.dataset.ty = ty;
        im.style.transform = z > 1.02 ? `translate(${tx}px,${ty}px) scale(${z})` : '';
      }
      const zoomTo = (im, z, cx, cy) => { const r = im.getBoundingClientRect(); im.dataset.z = z; im.parentElement.classList.add('is-zoom'); setPan(im, (cx - (r.left + r.width / 2)) * (1 - z), (cy - (r.top + r.height / 2)) * (1 - z)); };
      /* Pan (1 Finger / Maus im Zoom) und Pinch (2 Finger) */
      const ptrs = new Map(); let pan = null, pinch = null;
      lb.addEventListener('pointerdown', e => {
        const im = e.target.closest('.gh-lb__slide img'); if (!im) return;
        ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const zoomed = im.parentElement.classList.contains('is-zoom');
        if (ptrs.size === 2) {
          const [p, q] = [...ptrs.values()];
          pinch = { im, d0: dist(p, q), z0: +im.dataset.z || 1, tx: +(im.dataset.tx || 0), ty: +(im.dataset.ty || 0) }; pan = null; im.classList.add('is-pan'); e.preventDefault(); return;
        }
        if (!zoomed) return;
        e.preventDefault(); e.stopPropagation(); try { im.setPointerCapture(e.pointerId); } catch (x) {}
        pan = { im, x: e.clientX, y: e.clientY, tx: +(im.dataset.tx || 0), ty: +(im.dataset.ty || 0), moved: false }; im.classList.add('is-pan');
      });
      lb.addEventListener('pointermove', e => {
        if (ptrs.has(e.pointerId)) ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pinch && ptrs.size === 2) { const [p, q] = [...ptrs.values()]; const z = Math.max(1, Math.min(4, pinch.z0 * dist(p, q) / pinch.d0)); pinch.im.dataset.z = z; pinch.im.parentElement.classList.toggle('is-zoom', z > 1.02); setPan(pinch.im, pinch.tx, pinch.ty); e.preventDefault(); return; }
        if (!pan) return; const dx = e.clientX - pan.x, dy = e.clientY - pan.y; if (Math.abs(dx) + Math.abs(dy) > 4) pan.moved = true; setPan(pan.im, pan.tx + dx, pan.ty + dy);
      });
      const ptrEnd = e => {
        ptrs.delete(e.pointerId);
        if (pinch && ptrs.size < 2) { const im = pinch.im; im.classList.remove('is-pan'); if ((+im.dataset.z || 1) < 1.12) unzoom(im.parentElement); pinch = null; dragged = true; setTimeout(() => { dragged = false; }, 120); return; }
        if (!pan) return; pan.im.classList.remove('is-pan'); if (pan.moved) { dragged = true; setTimeout(() => { dragged = false; }, 60); } pan = null;
      };
      lb.addEventListener('pointerup', ptrEnd); lb.addEventListener('pointercancel', ptrEnd);
      const go = (i, smooth = true) => { idx = (i + pics.length) % pics.length; lbSlides.forEach(unzoom); tr.scrollTo({ left: idx * tr.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' }); paint(); };
      const close = () => { lb.classList.add('is-out'); setTimeout(() => lb.remove(), reduce ? 0 : 180); document.removeEventListener('keydown', keys); document.body.style.overflow = prevOverflow; };
      const prevOverflow = document.body.style.overflow;
      function keys(ev) { if (ev.key === 'Escape') { ev.stopPropagation(); close(); } else if (ev.key === 'ArrowRight') go(idx + 1); else if (ev.key === 'ArrowLeft') go(idx - 1); }
      lb.addEventListener('click', e => {
        if (e.target.closest('[data-lb-close]')) { close(); return; }
        const n = e.target.closest('[data-lb]'); if (n) { go(idx + (+n.dataset.lb)); return; }
        const d = e.target.closest('[data-lb-go]'); if (d) { go(+d.dataset.lbGo); return; }
        const im = e.target.closest('.gh-lb__slide img');
        if (im && !dragged) { const s = im.parentElement; if (!s.classList.contains('is-zoom')) zoomTo(im, Z, e.clientX, e.clientY); else unzoom(s); }
      });
      let st; tr.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => { const i = Math.round(tr.scrollLeft / tr.clientWidth); if (i !== idx) { idx = i; paint(); } }, 80); }, { passive: true });
      /* Maus-Drag am PC */
      let dx0 = null, sl0 = 0, dragged = false;
      tr.addEventListener('mousedown', e => { if (e.button !== 0 || e.target.closest('.gh-lb__slide.is-zoom')) return; dx0 = e.clientX; sl0 = tr.scrollLeft; dragged = false; tr.classList.add('is-drag'); e.preventDefault(); });
      addEventListener('mousemove', e => { if (dx0 === null) return; const d = e.clientX - dx0; if (Math.abs(d) > 6) dragged = true; tr.scrollLeft = sl0 - d; });
      addEventListener('mouseup', () => { if (dx0 === null) return; tr.classList.remove('is-drag'); dx0 = null; go(Math.round(tr.scrollLeft / tr.clientWidth)); setTimeout(() => { dragged = false; }, 50); });
      document.addEventListener('keydown', keys);
      document.body.style.overflow = 'hidden';
      document.body.appendChild(lb);
      go(idx, false); requestAnimationFrame(() => go(idx, false));
      $('.gh-lb__x', lb).focus();
    }
    track.addEventListener('click', e => {
      const s = e.target.closest('.gh-slide'); if (!s || s.classList.contains('gh-slide--video')) return;
      openLightbox(slides.indexOf(s));
    });
    setCur(0, false);
  }
  function gotoMedia(mediaId) { if (!mediaId) return; const i = slides.findIndex(s => s.dataset.mediaId == mediaId); if (i >= 0) setCur(i); }

  /* --- update everything from selection --- */
  const el = id => $('#' + id);
  let lastGalleryKey;
  function update(scrollMedia) {
    /* v = eindeutige Variante; ohne vollständige Auswahl rechnet alles mit der günstigsten passenden Variante c („ab …“) */
    const v = findVariant(sel);
    const cands = v ? [v] : (matches(sel).length ? matches(sel) : P.variants);
    const c = v || cands.slice().sort((a, b) => (a.available === b.available ? a.price - b.price : (a.available ? -1 : 1)))[0] || fallback;
    const pre = !v && cands.some(x => x.price !== c.price) ? GHt('ab') + ' ' : '';
    const unit = c.price, cmp = c.compare_at_price && c.compare_at_price > c.price ? c.compare_at_price : null;
    const total = unit * qty - ((S.packs || []).find(p => p.qty === qty) || { off: 0 }).off;
    if (idInput) idInput.value = v ? v.id : '';
    if (qtyInput) qtyInput.value = qty;
    form && form.classList.toggle('is-incomplete', !v);
    el('gh-price-now').textContent = pre + fmt(total);
    const was = el('gh-price-was'), badge = el('gh-price-badge'), sale = el('gh-badge-sale'), low = el('gh-lowest');
    if (cmp) {
      const ref = cmp * qty, pct = Math.round((1 - total / ref) * 100);
      was.textContent = pre + fmt(ref); was.hidden = false;
      badge.textContent = '−' + pct + ' %'; badge.hidden = false;
      if (sale) { sale.textContent = '−' + Math.round((1 - unit / cmp) * 100) + ' %'; sale.hidden = false; }
      if (low) { low.textContent = GHt('· Niedrigster Preis der letzten 30 Tage:') + ' ' + pre + fmt((c.lowest || cmp) * qty); low.hidden = false; }
    } else { was.hidden = true; badge.hidden = true; if (sale) sale.hidden = true; if (low) low.hidden = true; }
    $$('[data-optlabel]').forEach(l => { const di = +l.dataset.optlabel; l.textContent = sel[di] == null ? '' : (dims[di].style === 'swatches' ? sel[di] : (hintFor(sel[di]).label || '')); });
    renderPacks(unit);
    const missing = missingDims(), missingText = GHt('{name} wählen', { name: missing.map(i => esc(dims[i].name)).join(' ' + GHt('und') + ' ') });
    const chosen = sel.filter((s, i) => s != null && !dims[i].single).map(pretty).join(' · ');
    const mi = dims.findIndex(d => /modell|model/i.test(d.name)), modelTxt = mi >= 0 && sel[mi] ? `<span class="gh-atc__model"> · ${esc(pretty(sel[mi]))}</span>` : '';
    const avail = v ? v.available : cands.some(x => x.available);
    const btn = el('gh-atc'), txt = btn && btn.querySelector('span');
    if (btn) { btn.disabled = !avail; if (txt) txt.innerHTML = !avail ? GHt('Ausverkauft') : (!v ? missingText : `${GHt('In den Warenkorb')}${modelTxt} · <span class="gh-num">${fmt(total)}</span>`); }
    const buy = el('gh-buy-now'); if (buy) buy.disabled = !avail;
    delivery(avail);
    const sb = el('gh-sbar'); if (sb) { el('gh-sbar-price').textContent = pre + fmt(total); el('gh-sbar-var').textContent = v ? `${chosen}${chosen ? ' · ' : ''}${GHt('{n} Stück', { n: qty })}` : missingText; el('gh-sbar-btn').disabled = !avail; el('gh-sbar-btn').textContent = !avail ? GHt('Ausverkauft') : (v ? GHt('In den Warenkorb') : missingText); if (v && v.featured_image) el('gh-sbar-img').src = v.featured_image; }
    document.dispatchEvent(new CustomEvent('gh:variant', { detail: v ? v : Object.assign({}, c, { partial: true }) }));
    if (v) $$('[data-variant-field]').forEach(f => { const k = f.dataset.variantField; if (v[k] != null) f.textContent = v[k]; });
    const gKey = v ? (v.featured_media_id || 0) : null;
    if (galleryFilters) { if (gKey !== lastGalleryKey) { lastGalleryKey = gKey; applyGallery(v ? v.featured_media_id : null); } }
    else if (scrollMedia && v) gotoMedia(v.featured_media_id);
    if (history.replaceState) { const u = new URL(location.href); if (v) u.searchParams.set('variant', v.id); else u.searchParams.delete('variant'); history.replaceState({}, '', u); }
  }
  renderOptions(); update(false);
  setInterval(() => { if (typeof window.__ghDelivAvail === 'boolean') delivery(window.__ghDelivAvail); }, 30000);

  /* --- USP bullets: strip leading emoji, bold the lead phrase --- */
  $$('#gh-usps li span').forEach(s => {
    let t = s.textContent.replace(/^[^\p{L}\p{N}]+/u, '').trim();
    const m = t.match(/^(.{4,60}?)(\s[–-]\s|:\s)(.*)$/);
    if (m) { const b = document.createElement('b'); b.textContent = m[1]; s.textContent = ''; s.appendChild(b); s.appendChild(document.createTextNode(' – ' + m[3])); }
    else s.textContent = t;
  });

  /* --- add to cart (own, no theme scripts) --- */
  const err = $('#gh-form-error');
  const showErr = m => { if (err) { err.textContent = m; err.hidden = !m; } };
  /* Titelbild (erste Folie) als Flugbild; Startpunkt ist der sichtbare Galerie-Rahmen */
  const pdpImage = () => $('#gh-track .gh-slide img') || $('#gh-sbar-img') || null;
  const pdpStage = () => { const st = $('#gh-track'); if (st) { const r = st.getBoundingClientRect(); if (r.width > 0 && r.bottom > 40 && r.top < innerHeight - 40) return st; } return $('#gh-sbar.is-on #gh-sbar-img') || $('#gh-atc'); };
  async function submitAdd(goCheckout) {
    const v = findVariant(sel); if (!v) { needSelection(); return; } if (!v.available) return;
    const atc = el('gh-atc'), sp = atc.querySelector('.gh-spin');
    atc.setAttribute('aria-busy', 'true'); sp && (sp.hidden = false); showErr('');
    try {
      const sbOn = $('#gh-sbar.is-on'), btnEl = sbOn ? $('#gh-sbar-btn') : $('#gh-atc');
      await cart.add(new FormData(form), { silent: goCheckout, popup: !goCheckout, from: innerWidth < 1024 ? btnEl : pdpStage(), img: pdpImage() });
      if (goCheckout) window.location = '/checkout';
    } catch (e) { showErr(e.message); }
    atc.removeAttribute('aria-busy'); sp && (sp.hidden = true);
  }
  form && form.addEventListener('submit', e => { e.preventDefault(); submitAdd(false); });
  const buyNow = el('gh-buy-now');
  buyNow && buyNow.addEventListener('click', () => submitAdd(true));

  /* --- sticky bar --- */
  const sbar = el('gh-sbar'), atc = el('gh-atc');
  if (sbar && atc) {
    let buyOut = false, footIn = false;
    const upd = () => { const on = buyOut && !footIn; sbar.classList.toggle('is-on', on); sbar.setAttribute('aria-hidden', String(!on)); document.body.classList.toggle('gh-has-sbar', on); };
    new IntersectionObserver(([e]) => { buyOut = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }, { threshold: 0 }).observe(atc);
    const foot = document.querySelector('.gh-ftr');
    if (foot) new IntersectionObserver(([e]) => { footIn = e.isIntersecting; upd(); }, { threshold: 0 }).observe(foot);
    el('gh-sbar-btn').addEventListener('click', () => submitAdd(false));
  }

  /* --- mobile: main button floats at the bottom until its own position scrolls into view --- */
  if (atc && window.matchMedia('(max-width: 1023px)').matches) {
    const ph = document.createElement('div'); ph.className = 'gh-atc-ph'; atc.parentNode.insertBefore(ph, atc);
    let floating = null;
    const upd = () => {
      const h = atc.offsetHeight || 54, r = ph.getBoundingClientRect();
      const want = r.top > innerHeight - h - 12;
      if (want === floating) return; floating = want;
      ph.style.height = want ? h + 'px' : '0px';
      atc.classList.toggle('is-float', want);
    };
    addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd(); setTimeout(upd, 300);
  }

  /* --- footer: Linkspalten mobil als Akkordeon (Desktop immer offen per CSS) --- */
  document.addEventListener('click', e => {
    const b = e.target.closest('.gh-ftr__tog'); if (!b) return;
    const col = b.closest('.gh-ftr__col'); if (!col) return;
    const open = col.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* --- compatibility tool --- */
  const cb = $('#gh-c-brand'), cm = $('#gh-c-model'), cr = $('#gh-c-res');
  const compatEl = $('#gh-compat-json');
  const compatCfg = compatEl ? JSON.parse(compatEl.textContent) : S.compat;
  if (cb && cm && cr && compatCfg) {
    const models = compatCfg.models || {}, rules = compatCfg.rules || [];
    cb.addEventListener('change', () => { const list = models[cb.value] || []; cm.innerHTML = '<option value="">' + GHt('Modell wählen') + '</option>' + list.map(m => `<option>${esc(m)}</option>`).join(''); cm.disabled = !list.length; });
    cm.addEventListener('change', () => {
      const m = cm.value, b = cb.value; if (!m) return;
      const rule = rules.find(r => (r.brand === '*' || r.brand === b) && (!r.re || new RegExp(r.re.replace(/;/g, '|'), 'i').test(m))) || { cls: 'ok', title: GHt('Passt: {m}', { m }), text: '' };
      cr.className = 'gh-compat__res ' + rule.cls;
      cr.innerHTML = `<svg class="gh-ico"><use href="#${rule.cls === 'ok' ? 'gh-i-check' : 'gh-i-warn'}"/></svg><div><b>${esc(rule.title.replace('{m}', m))}</b><p>${esc((rule.text || '').replace('{m}', m))}</p></div>`;
      try { localStorage.setItem('gh-device', b + '|' + m); } catch (e) {}
    });
    try { const s = localStorage.getItem('gh-device'); if (s) { const [b, m] = s.split('|'); if (models[b]) { cb.value = b; cb.dispatchEvent(new Event('change')); cm.value = m; if (cm.value === m) cm.dispatchEvent(new Event('change')); } } } catch (e) {}
  }
})();

/* GreenHec — Kategorie/Katalog-Filter, Geräteauswahl (Entwurf 6.9.2026) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Filter-Sheet (mobil) ---------- */
  var sheetOpen = false;

  function plpOf(el) { return el.closest('.gh-plp'); }

  function openFilters(plp) {
    if (!plp) return;
    plp.classList.add('is-filters');
    var scrim = plp.querySelector('.gh-plp__scrim');
    if (scrim) scrim.hidden = false;
    document.body.style.overflow = 'hidden';
    sheetOpen = true;
    var btn = plp.querySelector('[data-gh-plp="open"]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var close = plp.querySelector('[data-gh-plp="close"].gh-ibtn');
    if (close) close.focus();
  }

  function closeFilters(plp) {
    var list = plp ? [plp] : $$('.gh-plp.is-filters');
    list.forEach(function (p) {
      p.classList.remove('is-filters');
      var scrim = p.querySelector('.gh-plp__scrim');
      if (scrim) scrim.hidden = true;
      var btn = p.querySelector('[data-gh-plp="open"]');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    });
    document.body.style.overflow = '';
    sheetOpen = false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gh-plp]');
    if (!t) return;
    e.preventDefault();
    if (t.dataset.ghPlp === 'open') openFilters(plpOf(t));
    else closeFilters(plpOf(t));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheetOpen) closeFilters();
  });

  /* ---------- Filter absenden ----------
     Desktop: jede Änderung lädt sofort neu. Mobil im Sheet: erst der Button „X Produkte zeigen“,
     sonst würde die Liste bei jedem Häkchen unter den Fingern wegspringen. */
  var timer = null;

  function submitFacets(form) {
    $$('input[type="number"]', form).forEach(function (i) { if (!i.value) i.disabled = true; });
    var btn = form.querySelector('.gh-fac__apply');
    if (btn) { btn.classList.add('is-busy'); btn.textContent = GHt('Wird geladen …'); }
    form.submit();
  }

  $$('[data-gh-facets]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      var plp = plpOf(form);
      if (plp && plp.classList.contains('is-filters')) return;
      clearTimeout(timer);
      var wait = e.target.type === 'number' ? 700 : 0;
      timer = setTimeout(function () { submitFacets(form); }, wait);
    });
    form.addEventListener('submit', function () {
      $$('input[type="number"]', form).forEach(function (i) { if (!i.value) i.disabled = true; });
    });
  });

  /* Sortierung liegt per form="…" außerhalb des Formulars und löst immer sofort aus. */
  $$('[data-gh-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.form || document.getElementById(sel.getAttribute('form'));
      if (form) submitFacets(form);
    });
  });

  /* ---------- Geräteauswahl ---------- */
  $$('[data-gh-devices]').forEach(function (box) {
    var tabs = $$('[data-gh-devtab]', box);
    var panels = $$('[data-gh-devpanel]', box);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-on'); t.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.add('gh-hidden'); });
        tab.classList.add('is-on');
        tab.setAttribute('aria-selected', 'true');
        var p = box.querySelector('[data-gh-devpanel="' + tab.dataset.ghDevtab + '"]');
        if (p) p.classList.remove('gh-hidden');
      });
    });

    /* Gemerkte Marke aus dem Kompatibilitäts-Check der Produktseite vorauswählen. */
    try {
      var saved = localStorage.getItem('gh-device');
      if (saved) {
        var brand = saved.split('|')[0].toLowerCase();
        var hit = tabs.filter(function (t) { return t.textContent.trim().toLowerCase().indexOf(brand) > -1; })[0];
        if (hit) hit.click();
      }
    } catch (err) {}
  });

  /* Klick auf ein Gerät merken, damit Produktseite und Kategorie dieselbe Auswahl kennen. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-gh-devpick]');
    if (!a) return;
    try { localStorage.setItem('gh-device', a.dataset.ghDevpick); } catch (err) {}
  });

  /* Gemerktes Gerät in den Chips der Kategorieseite markieren. */
  try {
    var s = localStorage.getItem('gh-device');
    if (s) {
      var model = (s.split('|')[1] || '').toLowerCase();
      if (model) {
        $$('[data-gh-dev]').forEach(function (c) {
          if (c.dataset.ghDev.toLowerCase() === model) c.classList.add('is-on');
        });
      }
    }
  } catch (err) {}
})();

/* GreenHec — Bewegung & Feinschliff für Startseite/Kategorie/Katalog (6.9.2026) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var io = 'IntersectionObserver' in window;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Einblenden beim Scrollen ----------
     Alles im ersten Viewport bleibt unangetastet: sonst würde das größte Bild
     erst nach dem Beobachter erscheinen und den LCP verzögern. */
  if (!calm && io) {
    var groups = [
      ['.gh-sec__head', 0],
      ['.gh-c', 1],
      ['.gh-tile', 1],
      ['.gh-quote', 1],
      ['.gh-step', 1],
      ['.gh-tl__b', 1],
      ['.gh-kpi__i', 1],
      ['.gh-deflist__r', 1],
      ['.gh-band > div', 1],
      ['.gh-story__img', 0],
      ['.gh-story__txt', 0],
      ['.gh-dev', 0],
      ['.gh-plp__seo', 0],
      ['.gh-faq details', 1],
      ['.gh-b2b', 0],
      ['.gh-brand', 0]
    ];
    var safe = window.innerHeight * 0.9;
    var targets = [];
    groups.forEach(function (g) {
      var stagger = g[1];
      var seenParents = new Map();
      $$(g[0]).forEach(function (el) {
        if (el.getBoundingClientRect().top < safe) return;
        var delay = 0;
        if (stagger) {
          var key = el.parentElement;
          var i = seenParents.get(key) || 0;
          seenParents.set(key, i + 1);
          delay = Math.min(i, 5) * 55;
        }
        el.classList.add('gh-reveal');
        if (delay) el.style.transitionDelay = delay + 'ms';
        targets.push(el);
      });
    });

    var revObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        revObs.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (t) { revObs.observe(t); });
  }

  /* ---------- Produktbilder sanft einblenden ---------- */
  if (!calm) {
    $$('.gh-c__i1').forEach(function (img) {
      if (img.complete) return;
      img.classList.add('gh-fadein');
      var done = function () { img.classList.add('is-in'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      setTimeout(done, 6000);
    });
  }

  /* ---------- Ladezustand beim Filtern ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-gh-facets]');
    if (!f) return;
    var plp = f.closest('.gh-plp');
    if (plp) plp.classList.add('is-loading');
  }, true);

  /* ---------- Bestätigung am Direkt-Kauf zurücksetzen ----------
     gh.js setzt is-ok und lässt es stehen. Nach kurzer Zeit wieder normal,
     damit ein zweiter Klick wieder Rückmeldung gibt. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.gh-c__cta[data-gh-add]');
    if (!b) return;
    setTimeout(function () { b.classList.remove('is-ok'); }, 1800);
  });

  /* ---------- Interne Sprungziele weich anfahren ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.hasAttribute('data-gh-open') || a.hasAttribute('data-gh-close') || a.hasAttribute('data-gh-plp')) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var t = document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(null, '', '#' + id);
  });

  /* ---------- Nach oben (nur auf langen Listenseiten) ---------- */
  var plpEl = $('.gh-plp');
  if (plpEl) {
    var top = document.createElement('button');
    top.type = 'button';
    top.className = 'gh-top';
    top.setAttribute('aria-label', GHt('Nach oben'));
    top.innerHTML = '<svg class="gh-ico" aria-hidden="true"><use href="#gh-i-chev"/></svg>';
    document.body.appendChild(top);
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: calm ? 'auto' : 'smooth' });
    });
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        top.classList.toggle('is-on', window.scrollY > window.innerHeight * 1.5);
        ticking = false;
      });
    }, { passive: true });
  }
})();

/* GreenHec — Hintergrundvideo im Banner (6.9.2026)
   Die Quelle steht absichtlich nicht im Markup: so lädt das Video weder vor dem Bild noch auf
   Geräten, auf denen es nichts bringt. Ohne JavaScript bleibt schlicht das Bild stehen. */
(function () {
  'use strict';
  var vids = Array.prototype.slice.call(document.querySelectorAll('.gh-bn__vid'));
  if (!vids.length) return;

  var conn = navigator.connection || navigator.webkitConnection;
  var thrifty = !!(conn && (conn.saveData || /^([23]g|slow-2g)$/.test(conn.effectiveType || '')));

  vids.forEach(function (v) {
    var src = v.dataset.ghVideo;
    if (!src) return;

    var allowMobile = v.dataset.ghVideoMobile === '1';
    var small = window.innerWidth < 750;
    // Diagnose per URL-Schalter ?ghvdebug: Zustand im Knopf, auch wenn der Start nie ausgelöst wird.
    var dbg = /ghvdebug/.test(location.search);
    var dbgWrap = v.parentElement, dbgBtn = dbgWrap && dbgWrap.querySelector('[data-gh-video-toggle]'), dbgLabel = dbgBtn && dbgBtn.querySelector('.gh-bn__vbtnt');
    var dbgReason = '';
    if (dbg && dbgLabel) {
      dbgBtn.hidden = false;
      ['stalled', 'waiting', 'suspend', 'error', 'abort', 'emptied', 'pause', 'ended', 'playing', 'play', 'loadeddata'].forEach(function (n) { v.addEventListener(n, function () { v.dataset.ghLast = n; }); });
      setInterval(function () {
        dbgLabel.textContent = 'v3 ' + v.currentTime.toFixed(1) + 's ' + (v.paused ? 'pausiert' : 'läuft') + ' rs' + v.readyState + ' ns' + v.networkState + (v.getAttribute('src') ? ' src' : ' nosrc') + (v.error ? ' err' + v.error.code : '') + (v.dataset.ghLast ? ' ' + v.dataset.ghLast : '') + (v.classList.contains('is-on') ? ' on' : ' off') + (document.hidden ? ' hidden' : '') + (thrifty ? ' thrifty' : '') + (small ? ' small' : '') + (dbgReason ? ' ' + dbgReason : '') + ' ' + Math.round(innerWidth) + 'px';
      }, 1000);
    }
    // Hochkant-Fassung nehmen, wenn es eine gibt: das Querformat wird auf dem Handy sonst zerschnitten.
    if (small && v.dataset.ghVideoM) src = v.dataset.ghVideoM;
    // Datensparmodus, langsame Verbindung oder Handy ohne Freigabe: Bild bleibt. „Bewegung reduzieren“
    // sperrt nicht mehr (14.9.2026): Windows setzt es bei „Animationseffekte aus“, das Video hat einen Pause-Knopf.
    if (thrifty || (small && !allowMobile)) { dbgReason = 'gesperrt'; return; }

    var wrap = v.parentElement;
    var btn = wrap ? wrap.querySelector('[data-gh-video-toggle]') : null;
    var label = btn ? btn.querySelector('.gh-bn__vbtnt') : null;
    var started = false;
    var failed = false;
    var userPaused = false;

    // Safari lehnt play() im Stromsparmodus ab. Ohne Aufräumen bliebe der erste Frame über dem
    // Standbild stehen und der Knopf behauptete „Video pausieren“, während nichts läuft.
    function giveUp() {
      v.removeAttribute('src');
      v.load();
      v.classList.remove('is-on');
      if (btn) btn.hidden = true;
      started = false;
      failed = true;
    }

    function play() {
      var p = v.play();
      if (p && p.catch) p.catch(function (e) {
        dbgReason = 'play:' + (e && e.name);
        // AbortError: Hintergrundtab oder unterbrochener Ladevorgang – später erneut, nicht aufgeben.
        if (e && e.name === 'AbortError') { started = false; return; }
        giveUp();
      });
    }

    var bound = false;
    function start() {
      if (started || failed) return;
      started = true;
      // Stumm per Eigenschaft, nicht nur per Attribut: Autoplay ist sonst blockiert oder läuft mit Ton.
      v.muted = true; v.defaultMuted = true; v.volume = 0;
      if (!v.getAttribute('src')) v.src = src;
      // 'playing' statt 'loadeddata': loadeddata feuert auch dann, wenn die Wiedergabe blockiert wird.
      if (!bound) { bound = true; v.addEventListener('playing', function () { v.classList.add('is-on'); if (btn) btn.hidden = false; }); }
      play();
    }

    // Im Hintergrundtab weiterlaufen zu lassen kostet Akku und bringt nichts.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { if (started && !v.paused) v.pause(); return; }
      if (userPaused || failed) return;
      if (!started) start(); else if (v.paused) play();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            start();
            if (started && v.paused && !userPaused) play();
          } else if (started && !v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.15 });
      io.observe(v);
    } else {
      start();
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (v.paused) {
          userPaused = false;
          play();
          if (label) label.textContent = GHt('Video pausieren');
          btn.setAttribute('aria-pressed', 'false');
        } else {
          userPaused = true;
          v.pause();
          if (label) label.textContent = GHt('Video abspielen');
          btn.setAttribute('aria-pressed', 'true');
        }
      });
    }
  });
})();

/* Bewertungs-Karussell (13.9.2026): Pfeile scrollen um eine Karte, an den Enden deaktiviert. */
(function () {
  document.querySelectorAll('[data-gh-qnav]').forEach(function (nav) {
    var sec = document.getElementById(nav.getAttribute('data-gh-qnav'));
    var t = sec && sec.querySelector('[data-gh-qrail]');
    var prev = nav.querySelector('[data-gh-prev]'), next = nav.querySelector('[data-gh-next]');
    if (!t || !prev || !next) return;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function step() { var c = t.children; return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : t.clientWidth * 0.8; }
    function upd() { prev.disabled = t.scrollLeft <= 2; next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2; }
    prev.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); setTimeout(upd, 500); });
    next.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); setTimeout(upd, 500); });
    t.addEventListener('scroll', upd, { passive: true });
    t.addEventListener('scrollend', upd);
    addEventListener('resize', upd);
    upd();

    /* Autoplay: alle N Sekunden eine Karte weiter, am Ende zurück zum Anfang. Pausiert bei Maus darüber,
       Tastaturfokus, Berührung und im Hintergrund-Tab; respektiert prefers-reduced-motion. */
    var secs = parseInt(t.getAttribute('data-gh-auto'), 10) || 0;
    if (!secs || reduce) return;
    var timer = null, hold = false;
    function tick() {
      if (hold || document.hidden) return;
      if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 2) t.scrollTo({ left: 0, behavior: 'smooth' });
      else t.scrollBy({ left: step(), behavior: 'smooth' });
      setTimeout(upd, 500);
    }
    function start() { stop(); timer = setInterval(tick, secs * 1000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function pause() { hold = true; }
    function resume() { hold = false; start(); }
    t.addEventListener('pointerenter', pause); t.addEventListener('pointerleave', resume);
    t.addEventListener('focusin', pause); t.addEventListener('focusout', resume);
    t.addEventListener('touchstart', pause, { passive: true }); t.addEventListener('touchend', resume, { passive: true });
    nav.addEventListener('click', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  });
})();

/* Tab-Aufmerksamkeit (1.10.2026): Ist der Tab im Hintergrund, erzählt der Tab eine kleine Geschichte im Duolingo-Ton,
   direkte Du-Ansprache, Maskottchen = zwei gezeichnete Augen auf GreenHec-Türkis im Favicon (suchen, schielen zu den
   Nachbartabs, schlafen ein). Zeitachse in Sekunden seit dem Verlassen, Takt 1 s; ab 300 s (Chrome drosselt dann auf 1 Tick/Minute) Eskalationsstufen nach Minuten, eine Zeile je Minute:
   0–14 suchen · 14–44 Akku lädt (Augen im Favicon schauen zum Balken) · 44–52 „100 %. Und du so?“ · 52–64 Magnet zieht 📱 heran ·
   64–74 🚗💨 fährt los · 74–80 allein · 80–104 Augen schielen zu den anderen Tabs · danach Schlaf (Originaltitel, geschlossene Augen).
   Titel höchstens 22 Zeichen, weil Chrome-Tabs danach abschneiden. Emoji nie doppelt: steht es im Favicon, fehlt es im Titel.
   Zurück im Tab wird alles wiederhergestellt. Vorschau in der Konsole: GHtab.preview(sekunden). */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  /* Bewusst ohne prefers-reduced-motion: Windows ohne „Animationseffekte“ meldet reduce, und ein Tab-Titel ist keine Bewegung auf der Seite.
     Der 6-s-Takt dafür hatte die Animationen bei Paul eingefroren (ein 12-s-Schwenk = 2 Bilder). */
  var origTitle = document.title, timer = null, t0 = 0, cache = {};
  var link = document.querySelector('link[rel="icon"]');
  var origIcon = link ? link.getAttribute('href') : '';
  var ROUND = 300;
  function cartCount() {
    var c = window.GHcart && window.GHcart.last;
    if (c && typeof c.item_count === 'number') return c.item_count;
    var el = document.getElementById('gh-cart-n');
    return el ? (parseInt((el.textContent || '').replace(/\D/g, ''), 10) || 0) : 0;
  }
  function rep(ch, n) { var o = ''; while (n-- > 0) o += ch; return o; }
  function bar(p) { var k = Math.round(p / 100 * 8); return rep('▰', k) + rep('▱', 8 - k); }
  /* Eine Szene je Sekunde. e = Favicon-Schlüssel „eye:c|l|r|u|dl|dr|s|z|n“ (nur Augen; anderes war in 16 px zu klein).
     t ohne Titel (t: null) heißt: Originaltitel zeigen, nur das Favicon erzählt weiter. */
  function frame(t) {
    var n = cartCount();
    if (t >= ROUND) return late(t, n);
    var u = t;
    if (u < 4) return { e: u < 1 ? 'eye:w' : 'eye:c', t: GHt('Du bist noch da?') };
    if (u < 10) return { e: Math.floor(u) % 2 ? 'eye:r' : 'eye:l', t: u < 7 ? GHt('Hallo?') : GHt('Hallo? Hallo?') };
    if (u < 14) return { e: 'eye:c', t: GHt('Okay. Kein Stress.') };
    /* Akku lädt, die Augen im Favicon schauen zum Balken (Lauf durch den Titel auf Pauls Wunsch entfernt). */
    if (u < 44) {
      var p = Math.min(100, Math.round((u - 14) / 29 * 100));
      var lead = n > 0 ? GHt('Deins:') : GHt('Lädt:');
      return { e: p >= 100 ? 'eye:w' : 'eye:r', t: lead + ' ' + p + ' % ' + bar(p) };
    }
    if (u < 52) return { e: u < 46 ? 'eye:w' : Math.floor(u) % 2 ? 'eye:u' : 'eye:c', t: GHt('100 %. Und du so?') };
    /* „─“ statt „·“: der Mittelpunkt ist in der Tableiste nur 3 px breit, da sieht man keine Bewegung. */
    if (u < 64) { var d = Math.floor((63 - u) / 1.5); return d > 0 ? { e: 'eye:r', t: rep('─', d) + '📱 ' + GHt('Komm her.') } : { e: 'eye:c', t: '📱 ' + GHt('Geht doch.') }; }
    if (u < 74) { var x = Math.min(6, Math.floor(u) - 64); return { e: 'eye:r', t: rep('─', x) + '🚗💨 ' + (n > 0 ? GHt('Ohne Paket.') : GHt('Ohne dich.')) }; }
    if (u < 80) return { e: 'eye:s', t: n > 0 ? GHt('{n} Artikel. Allein.', { n: n }) : GHt('Ganz allein hier.') };
    if (u < 86) return { e: Math.floor(u) % 2 ? 'eye:dl' : 'eye:dr', t: GHt('Was gibt es da drüben?') };
    if (u < 92) return { e: 'eye:s', t: GHt('Aha. Spannender.') };
    if (u < 98) return { e: 'eye:dr', t: GHt('Bestimmt ganz wichtig.') };
    /* Blinkende Aufforderung, Pfeil zeigt auf die Augen im Favicon. */
    if (u < 108) return Math.floor(u) % 2 ? { e: 'eye:s', t: GHt('Klick mich.') } : { e: 'eye:c', t: '👈 ' + GHt('Klick mich.') };
    /* Traurig, dann aufgeben. */
    if (u < 111) return { e: 'eye:sd', t: GHt('Pff.') };
    if (u < 114) return { e: 'eye:sd', t: GHt('Schon gut.') };
    if (u < 117) return { e: 'eye:sd', t: GHt('Dann eben nicht.') };
    if (u < 122) return { e: 'eye:z', t: null };
    /* Die Jagd: Augen reißen auf, das Logo kehrt ins Favicon zurück, die Augen rennen schreiend aus der Zeile. */
    if (u < 124) return { e: 'eye:w', t: GHt('Oh nein.') };
    if (u < 132) {
      var r = Math.floor(u) - 124, pos = [0, 1, 3, 5, 7, 9, 11, 12][r];
      var cry = r < 2 ? GHt('Aah!') : r < 4 ? GHt('Aaah!') : GHt('AAAH!');
      return { e: 'logo:' + (r % 2), t: rep('─', pos) + '👀💨 ' + cry };
    }
    if (u < 134) return { e: 'logo:0', t: rep('─', 12) + '💨' };
    if (u < 137) return { e: 'orig', t: rep('─ ', 6) };
    return { e: 'orig', t: null };
  }
  /* Ab 5 Minuten drosselt Chrome Hintergrund-Timer auf einen Aufruf pro Minute. Deshalb ab hier eine Zeile je Minute,
     Stufen nach Minuten seit dem Verlassen, mit der Zeit zunehmend beleidigt. Augen wechseln je Minute. */
  function late(t, n) {
    var m = Math.floor(t / 60), L;
    if (m < 15) L = [GHt('Immer noch drüben?'), GHt('Wir warten. Geduldig.'), GHt('Noch da. Nur so.')];
    else if (m < 30) L = [GHt('15 Minuten. Okay.'), GHt('Nicht persönlich.'), GHt('Doch. Ein bisschen.')];
    else if (m < 60) L = [GHt('Halbe Stunde. Hm.'), GHt('Fremdgegangen?'), GHt('Wir waren fleißig. Du?')];
    else if (m < 120) L = [GHt('Eine Stunde. Wow.'), GHt('Vergessen wir das?'), GHt('Nicht sauer. Traurig.'), GHt('Dreimal voll geladen.')];
    else if (m < 240) L = [GHt('Zwei Stunden. Respekt.'), GHt('Tab schließen? Scherz.'), GHt('Wir kennen dich jetzt.')];
    else L = [GHt('Wir wohnen jetzt hier.'), GHt('Morgen. Oder Abend.'), GHt('Schließen ist okay.'), GHt('Falls du liest: Hi.')];
    if (n > 0 && m >= 15) L.push(m >= 60 ? GHt('{n} Artikel. Seit Stunden.', { n: n }) : GHt('{n} Artikel. Warten.', { n: n }));
    var E = ['eye:c', 'eye:s', 'eye:l', 'eye:z', 'eye:r'];
    return { e: E[m % E.length], t: L[m % L.length] };
  }
  /* mode = Blick (c/l/r/u/dl/dr/s/z/n/b), v = Variante 0–3 für kleine Pupillenbewegungen, damit die Augen jede Sekunde leben. */
  function eyes(x, key) {
    /* Nur zwei Augen wie beim 👀-Emoji, so groß wie die Fläche hergibt, ohne Hintergrund; dunkle Kontur, damit sie auch auf heller Tableiste stehen. */
    var parts = key.split(':'), mode = parts[0], v = parseInt(parts[1], 10) || 0;
    if (mode === 'n') return; /* Augen sind unterwegs (laufen durch den Titel) */
    var jx = [0, 1, 0, -1][v], jy = [0, 0, 1, 0][v];
    var dx = (mode === 'l' || mode === 'dl' ? -5 : mode === 'r' || mode === 'dr' ? 5 : 0) + jx;
    var dy = (mode === 'u' ? -8 : mode === 'dl' || mode === 'dr' ? 9 : mode === 'sd' ? 11 : mode === 'w' ? 0 : 3) + jy;
    var ry = mode === 's' ? 10 : mode === 'b' ? 7 : mode === 'sd' ? 18 : 26 - (v === 2 ? 1 : 0);
    var pr = mode === 'w' ? 6 : 8.5;
    x.lineWidth = 3; x.strokeStyle = '#131A1F'; x.lineCap = 'round';
    [16, 48].forEach(function (cx) {
      /* Geschlossene Augen: weißer Strich mit dunkler Kontur, sonst unsichtbar auf dunkler Tableiste. */
      if (mode === 'z') {
        x.beginPath(); x.arc(cx, 26 + (v % 2), 12, Math.PI * 0.15, Math.PI * 0.85);
        x.strokeStyle = '#131A1F'; x.lineWidth = 10; x.stroke();
        x.strokeStyle = '#FFFFFF'; x.lineWidth = 5; x.stroke();
        x.strokeStyle = '#131A1F'; x.lineWidth = 3;
        return;
      }
      x.fillStyle = '#FFFFFF'; x.beginPath(); x.ellipse(cx, 32, 14.5, ry, 0, 0, Math.PI * 2); x.fill(); x.stroke();
      x.fillStyle = '#131A1F'; x.beginPath(); x.arc(cx + dx, 32 + (mode === 's' || mode === 'b' ? 0 : dy), pr, 0, Math.PI * 2); x.fill();
      if (mode === 'sd') { x.lineWidth = 4; x.beginPath(); x.moveTo(cx - 12, 14); x.lineTo(cx + 12, 10 + (cx < 32 ? 0 : 8)); x.stroke(); x.lineWidth = 3; } /* hängende Brauen */
    });
  }
  function icon(key) {
    if (key === 'orig') return origIcon;
    if (cache[key]) return cache[key];
    if (key.indexOf('logo:') === 0) {
      if (!logoImg || !logoImg.complete || !logoImg.naturalWidth) return origIcon;
      try {
        var lc = document.createElement('canvas'); lc.width = lc.height = 32; var lx = lc.getContext('2d');
        var lunge = key === 'logo:1' ? 5 : 0; /* springt Richtung Titel (rechts) */
        lx.drawImage(logoImg, lunge, 0, 32 - lunge * 0.4, 32);
        cache[key] = lc.toDataURL('image/png');
      } catch (err) { cache[key] = origIcon; }
      return cache[key];
    }
    try {
      /* 32 px reichen für ein Favicon; halb so groß = schneller gezeichnet, kodiert und dekodiert. Zeichnung bleibt in 64er-Koordinaten. */
      var c = document.createElement('canvas'); c.width = c.height = 32; var x = c.getContext('2d'); x.scale(0.5, 0.5);
      eyes(x, key.indexOf('eye:') === 0 ? key.slice(4) : 'c'); /* nur Augen: Emoji und Batterie waren in 16 px zu klein */
      cache[key] = c.toDataURL('image/png');
    } catch (err) { cache[key] = origIcon; }
    return cache[key];
  }
  /* Element austauschen statt href ändern: Chrome lädt ein geändertes href im Hintergrund-Tab nicht zuverlässig neu. */
  function setIcon(href) {
    if (!href) return;
    var nl = document.createElement('link'); nl.rel = 'icon'; nl.type = 'image/png'; nl.href = href;
    if (link && link.parentNode) link.parentNode.replaceChild(nl, link); else document.head.appendChild(nl);
    link = nl;
  }
  /* Leben in den Augen: jede 5. Sekunde ein Blinzeln, dazwischen wandern die Pupillen minimal (Variante 0–3). */
  function live(key, sec) {
    if (key === 'eye:n' || key === 'orig' || key.indexOf('logo:') === 0) return key;
    if (key !== 'eye:z' && sec % 5 === 4) return 'eye:b';
    return key + ':' + (sec % 4);
  }
  var lastTitle = null, lastKey = null;
  function tick() {
    try {
      var t = (Date.now() - t0) / 1000;
      var f = frame(t);
      var title = f.t == null ? origTitle : f.t;
      if (title !== lastTitle) { document.title = title; lastTitle = title; } /* nur bei Änderung schreiben */
      var key = live(f.e, Math.floor(t));
      if (key !== lastKey) { setIcon(icon(key)); lastKey = key; }
    } catch (err) { /* ein kaputtes Bild darf die Geschichte nicht anhalten */ }
  }
  /* Chrome gibt Hintergrund-Tabs nur ~10 ms Rechenzeit je Sekunde. Jede Sekunde ein neues Bild zu zeichnen und zu kodieren
     hat das Budget nach rund einer Minute aufgebraucht (Paul: hängt bei „Komm her“ 15 s). Deshalb alle Bilder vorab zeichnen,
     solange der Tab sichtbar ist; im Hintergrund kostet ein Tick dann nur noch den Austausch des Link-Elements. */
  var warmed = false, logoImg = null;
  function warm() {
    if (warmed) return;
    warmed = true;
    var keys = ['eye:b', 'eye:n'];
    ['c', 'l', 'r', 'u', 'dl', 'dr', 's', 'sd', 'w', 'z'].forEach(function (m) { for (var v = 0; v < 4; v++) keys.push('eye:' + m + ':' + v); });
    keys.push('logo:0', 'logo:1');
    var i = 0;
    function step() {
      for (var n = 0; i < keys.length && n < 6; n++) icon(keys[i++]);
      if (i < keys.length) setTimeout(step, 120);
    }
    if (origIcon && !logoImg) { logoImg = new Image(); logoImg.crossOrigin = 'anonymous'; logoImg.onload = function () { delete cache['logo:0']; delete cache['logo:1']; icon('logo:0'); icon('logo:1'); }; logoImg.src = origIcon; }
    setTimeout(step, 50);
  }
  if (!document.hidden) setTimeout(warm, 1500);
  /* Mehrere Tabs der Seite offen: dann keine Geschichte (Paul). Tabs melden sich über einen BroadcastChannel,
     Heartbeat alle 20 s, ein Tab gilt 150 s als anwesend (Chrome drosselt Timer in Hintergrund-Tabs auf 1/min). */
  var peers = {}, me = Math.random().toString(36).slice(2), bc = null;
  try { bc = new BroadcastChannel('gh-tab'); } catch (e) {}
  function others() { var n = Date.now(), c = 0; for (var k in peers) { if (n - peers[k] < 150000) c++; else delete peers[k]; } return c; }
  if (bc) {
    bc.onmessage = function (e) {
      var d = e.data || {}; if (!d.id || d.id === me) return;
      if (d.t === 'bye') { delete peers[d.id]; if (document.hidden && !timer && !others()) away(); return; }
      var fresh = !peers[d.id]; peers[d.id] = Date.now();
      if (d.t === 'hi') bc.postMessage({ t: 'here', id: me });
      if (fresh && timer) back();
    };
    bc.postMessage({ t: 'hi', id: me });
    setInterval(function () { bc.postMessage({ t: 'here', id: me }); }, 20000);
    var bye = function () { try { bc.postMessage({ t: 'bye', id: me }); } catch (e) {} };
    window.addEventListener('pagehide', bye); window.addEventListener('beforeunload', bye);
  }
  function away() { if (timer || others() > 0) return; t0 = Date.now(); origTitle = document.title; lastTitle = null; lastKey = null; tick(); timer = setInterval(tick, 1000); }
  function back() { if (!timer) return; clearInterval(timer); timer = null; document.title = origTitle; setIcon(origIcon); }
  document.addEventListener('visibilitychange', function () { if (document.hidden) away(); else { back(); warm(); } });
  window.addEventListener('pagehide', back);
  window.GHtab = { preview: function (t) { var f = frame(t); return (f.t == null ? '(Originaltitel)' : f.t) + '  [' + f.e + ']'; }, icon: icon, warm: warm, others: others };
})();


/* ---------- KI-Hinweis an Bildern (snippets/gh-ai-note): ein Tooltip am body, Hover/Fokus/Tippen ---------- */
(function () {
  var tip = null, cur = null;
  function el() { if (!tip) { tip = document.createElement('div'); tip.className = 'gh gh-ai__tip'; tip.setAttribute('role', 'tooltip'); tip.hidden = true; document.body.appendChild(tip); } return tip; }
  function place() {
    if (!cur) return; var t = el(), r = cur.getBoundingClientRect(), w = Math.min(300, window.innerWidth - 24);
    t.style.width = w + 'px'; var x = Math.min(Math.max(12, r.right - w), window.innerWidth - w - 12); t.style.left = x + 'px';
    var h = t.offsetHeight, y = r.top - 8 - h; if (y < 8) y = r.bottom + 8; t.style.top = y + 'px';
  }
  function show(b) { cur = b; var t = el(); t.textContent = b.getAttribute('data-text') || ''; t.hidden = false; place(); }
  function hide() { if (tip) tip.hidden = true; cur = null; }
  function closeAll() { document.querySelectorAll('[data-gh-ai].is-open').forEach(function (x) { x.classList.remove('is-open'); }); hide(); }
  document.addEventListener('mouseover', function (e) { var b = e.target.closest && e.target.closest('[data-gh-ai]'); if (b && b !== cur) show(b); });
  document.addEventListener('mouseout', function (e) { var b = e.target.closest && e.target.closest('[data-gh-ai]'); if (b && !b.contains(e.relatedTarget) && !b.classList.contains('is-open')) hide(); });
  document.addEventListener('focusin', function (e) { var b = e.target.closest && e.target.closest('[data-gh-ai]'); if (b) show(b); });
  document.addEventListener('focusout', function (e) { var b = e.target.closest && e.target.closest('[data-gh-ai]'); if (b && !b.classList.contains('is-open')) hide(); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gh-ai]');
    if (b) { e.preventDefault(); e.stopPropagation(); if (b.classList.contains('is-open')) { closeAll(); } else { closeAll(); b.classList.add('is-open'); show(b); } return; }
    if (cur) closeAll();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); if ((e.key === 'Enter' || e.key === ' ') && e.target.hasAttribute && e.target.hasAttribute('data-gh-ai')) { e.preventDefault(); e.target.click(); } });
  window.addEventListener('scroll', function () { if (cur) place(); }, { passive: true });
  window.addEventListener('resize', function () { if (cur) place(); });
})();
